export default {
    route: {
        dashboard: 'Skjáborð',
        article: 'Greinar',
    },
    navbar: {
        logOut: 'Skrá út',
        myProfile: 'Aðgangurinn minn',
        termsConditions: 'Skilmálar',
    },
    month: {
        jan: 'Janúar',
        feb: 'Febrúar',
        mar: 'Mars',
        apr: 'Apríl',
        may: 'Maí',
        jun: 'Júní',
        jul: 'Júlí',
        aug: 'Ágúst',
        sep: 'September',
        oct: 'Október',
        nov: 'Nóvember',
        dec: 'Desember',
    },
    week: {
        mon: 'Má',
        tue: 'Þr',
        wed: 'Mi',
        thu: 'Fi',
        fri: 'Fö',
        sat: 'La',
        sun: 'Su',
    },
    login: {
        title: 'Innskráning : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        logIn: 'Skrá inn',
        username: 'Notandanafn',
        password: 'Lykilorð',
        loginForm: {
            header: 'Velkomin til ##COMPANY_BRAND_NAME##',
        },
        qrCode: {
            header: 'Sláðu inn kóðann í auðkennisforritinu þínu.',
            subheader: 'Sláðu inn 6 tölustafa kóðann hér að neðan til að halda áfram',
            placeholderSecurityCode: 'Sláðu inn öryggiskóðann hér',
        },
        forgotPassword: {
            header: 'Gleymdirðu lykilorðinu?',
            subheader:
                'Sláðu inn netfangið þitt hér að neðan og við munum senda þér póst til að endurstilla lykilorðið þitt',
            placeholderEmail: 'Sláðu inn netfangið þitt',
        },
        resetPassord: {
            header: 'Endurstilltu lykilorðið þitt.',
            subheader: 'Vinsamlega sláðu inn kóðann sem við sendum þér í tölvupósti og endurstilltu lykilorðið þitt.',
            placeholder: {
                code: 'Sláðu inn kóðann þinn',
                newPassWord: 'Sláðu inn nýja lykilorðið þitt',
                confirmPassWord: 'Endurstaðfestu lykilorð',
            },
            success: 'Lykilorðið þitt hefur verið endurstillt.',
        },
        button: {
            login: 'Skrá inn',
            forgotPassword: 'Gleymt lykilorð?',
            resetMyPassword: 'Endurstilla lykilorðið mitt',
            submitMyPassword: 'Vista nýtt lykilorð',
            back: 'Til baka',
            instavolt: '##COMPANY_BRAND_NAME##',
        },
        label: {
            rememberMe: 'Muna eftir mér',
            password: 'Lykilorð',
            userId: 'Notendaauðkenni',
            copyright: 'Höfundaréttur ##COMPANY_BRAND_NAME##.',
            showPassword: 'Sýna lykilorð',
            hidePassword: 'Fela lykilorð',
        },
        errors: {
            email: {
                email: 'Vinsamlega sláðu inn gilt netfang.',
                required: 'Vinsamlega sláðu inn netfangið þitt.',
            },
            password: {
                required: 'Vinsamlega sláðu inn lykilorðið þitt.',
                max: 'Lykilorð þarf að vera að minnsta kosti 8 stafir',
            },
            securityCode: {
                required: 'Vinsamlega sláðu inn öryggiskóðann þinn.',
                max: 'Öryggiskóði þarf að vera að minnsta kosti 6 stafir',
            },
            verificationCodeInvalid: 'Ógildur staðfestingarkóði.',
            generalError: 'Villa kom upp við úrvinnslu beiðninnar þinnar.',
            incorrectCredentials: 'Rangt notendanafn eða lykilorð.',
            defaultPasswordExpired: 'Lykilorðið þitt er útrunnið, kerfisstjóri þarf að endurstilla það.',
            inValidEmailAddress: 'Ógilt netfang.',
            securityCodeInvalid: 'Rangur öryggiskóði.',
            verificationCodeFormat: 'Vinsamlega sláðu inn 6 tölustafa staðfestingarkóða.',
            passwordFormat:
                'Lykilorð verður að vera 15+ stafir og innihalda að minnsta kosti einn lágstaf, einn hástaf, sérstaf og tölustaf.',
            confirmPasswordMatch: 'Lykilorð og staðfesting lykilorðs verður að stemma.',
            common: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
        },
        toast: {
            error: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
        },
    },
    dashboard: {
        title: 'Heim : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Skjáborð',
        formtitle: 'Staðfesting forms',
        label: {
            pending: 'Í bið',
            currentBalance: 'Núverandi innistæða',
            closingBalance: 'Lokunarstaða',
            availableCredit: 'Inneign í boði',
            unbilledAmount: 'Órukkuð upphæð',
            filter: 'Sía',
            reportTags: 'Tilkynna merki',
            driverGroup: 'Bílstjórahópar',
            selectDriverGroup: 'Velja bílstjórahópa',
            selectTags: 'Velja merki',
            dateRange: 'Tímabil',
            month: 'Mánuður',
            year: 'Ár',
            day: 'Dagur',
            week: 'Vika',
            userSessionTitle: 'Lotur ökumanns',
            userSessions: 'Lotur ökumanns',
            expenseTitle: 'Samtals kostnaður',
            expense: 'Útgjöld',
            energyTitle: 'Heildarorka (kWh)',
            enrgy: 'Orka',
            averageTransationTitle: 'Meðaltalsfærslur',
            transaction: 'Færsla',
            creditLimit: 'Inneignarmörk',
            totalDriverAccounts: 'Samtals aðgangar bílstjóra',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
        },
        button: {
            apply: 'Bæta við',
            clear: 'Hreinsa',
        },
        cpoType: {
            Both: 'Bæði',
            Local: 'Innlent',
            International: 'Alþjóðlegt',
        },
    },
    permission: {
        createArticle: 'Bæta við grein',
        editArticle: 'Breyta grein',
        save: 'Vista',
        confirm: 'Ertu viss?',
        cancel: 'Hætta við',
        update: 'Uppfæra',
    },
    table: {
        pagination: {
            prev: 'Fyrri',
            nrev: 'Næsti',
            showing: 'Sýni',
        },
        data: {
            noData: 'Engin gögn fundust.',
        },
    },
    article: {
        title: 'Stjórna grein',
        id: 'Auðkenni greinar',
        date: 'Dagsetning',
        tabletitle: 'Titill',
        author: 'Höfundur',
        reviewer: 'Umsagnaraðili',
        actions: 'Aðgerðir',
        saveMessage: 'Tókst að vista grein',
        updateMessage: 'Tókst að uppfæra grein',
        deleteMessage: 'Tókst að eyða grein',
    },
    user: {
        title: 'Notendur : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        user: 'Notendur',
        manageUser: 'Stjórna notanda',
        placeholder: {
            name: 'Nafn',
            email: 'Netfang',
            phoneNo: 'Símanr.',
            firstName: 'Skírnarnafn',
            lastName: 'Föðurnafn',
            userGroup: 'Notendahópar',
            userRoles: 'Hlutverk notenda',
            Organisation: 'Stofnun',
            select: 'Velja stöðu',
            selectOrganisation: 'Velja stofnun',
            selectUserGroup: 'Velja notendahóp',
            languagePreference: 'Valið tungumál',
        },
        label: {
            firstName: 'Skírnarnafn',
            lastName: 'Föðurnafn',
            email: 'Netfang',
            phoneNo: 'Símanr.',
            optional: '(Valkvætt)',
            userGroups: 'Notendahópar',
            userRoles: 'Hlutverk notenda',
            Organisation: 'Stofnun',
            createdDate: 'Stofndags.',
            id: 'Auðkenni',
            action: 'Aðgerð',
            status: 'Staða',
            name: 'Nafn',
            delete: 'Eyða',
            enable: 'Virkja',
            all: 'Allt',
            disable: 'Afvirkja',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            pending: 'Í bið',
            reset2FA: 'Endurstilla 2 þátta auðkenningu',
            deleted: 'Eytt',
            lastLoginDate: 'Síðast skráð inn dags.',
            languagePreference: 'Valið tungumál',
        },
        button: {
            search: 'Leita',
            cancel: 'Hætta við',
            save: 'Vista',
            add: 'Bæta við',
            edit: 'Breyta',
            reset: 'Endurstilla',
            delete: 'Eyða',
            yes: 'Já',
            no: 'Nei',
            enabled: 'Virkja',
            disabled: 'Afvirkja',
            action: 'Aðgerð',
            back: 'Til baka',
            sendEmail: 'Senda tölvupóst',
            reset2FA: 'Endurstilla 2 þátta auðkenningu',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
            sendMailConfirmMessage: 'Ertu viss um að þú viljir senda tölvupóst?',
            mailSentSuccessMessage: 'Tókst að senda tölvupóst.',
            reset2FAConfirmMesage: 'Ertu viss um að þú viljir endurstilla 2 þátta auðkenningu fyrir þennan notanda?',
        },
        errors: {
            email: {
                required: 'Vinsamlega sláðu inn netfang',
                email: 'Vinsamlega sláðu inn gilt netfang.',
            },
            firstName: {
                required: 'Vinsamlega sláðu inn skírnarnafn',
                valid: 'Vinsamlega sláðu inn gilt skírnarnafn',
            },
            lastName: {
                required: 'Vinsamlega sláðu inn föðurnafn',
                valid: 'Vinsamlega sláðu inn gilt föðurnafn',
            },
            phoneNo: {
                required: 'Vinsamlega sláðu inn símanúmerið þitt',
                match: 'Vinsamlega sláðu inn gilt símanúmer',
            },
            userGroups: {
                required: 'Vinsamlega veldu að minnsta kosti einn notendahóp',
            },
            organization: {
                required: 'Vinsamlega veldu stofnun',
            },
        },
    },
    userGroup: {
        title: 'Notendahópar : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        manageUserGroup: 'Sjá um notendahóp',
        users: 'Notendur',
        header: 'Notendahópar',
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            edit: 'Breyta',
            delete: 'Eyða',
            save: 'Vista',
            cancel: 'Hætta við',
            yes: 'Já',
            no: 'Nei',
            action: 'Aðgerð',
            add: 'Bæta við',
            back: 'Til baka',
            enable: 'Virkja',
            disable: 'Afvirkja',
            permission: 'Aðgangsheimildir',
        },
        placeholder: {
            groupName: 'Notendahópur',
            users: 'Velja notendur',
            select: 'Velja stöðu',
            organisation: 'Velja stofnun',
        },
        message: {
            deleteConfirmMesageForOrganistion:
                'Með því að eyða þessum stofnanahóp eyðum við tengingu hóps við ákveðna stofnun. Ertu viss um að þú viljir halda áfram?',
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
        },
        label: {
            id: 'Auðkenni',
            name: 'Nafn',
            description: 'Lýsing',
            Organisation: 'Stofnun',
            createdBy: 'Búið til af',
            status: 'Staða',
            modifiedBy: 'Breytt af',
            createdDate: 'Stofndags.',
            modifiedDate: 'Dagsetning breytingar',
            action: 'Aðgerð',
            groupName: 'Notendahópur',
            delete: 'Eyða',
            enable: 'Virkja',
            disable: 'Afvirkja',
            phoneNo: 'Símanúmer',
            email: 'Netfang',
            groupAccess: 'Aðgangur hóps',
            selectUsers: 'Velja notendur',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            yes: 'Já',
            no: 'Nei',
        },
        form: {
            groupName: {
                label: 'Notendahópur',
                placeholder: 'Sláðu inn notendahóp',
            },
            description: {
                label: 'Lýsing',
                placeholder: 'Sláðu inn lýsingu',
            },
            Organisation: {
                label: 'Stofnun',
            },
        },
        errors: {
            groupName: {
                required: 'Vinsamlega sláðu inn nafn hóps',
                valid: 'Vinsamlega sláðu inn gilt nafn hóps',
                max: 'Hámark 50 stafir',
            },
            description: {
                max: 'Hámark 255 stafir',
            },
            userList: {
                required: 'Vinsamlega veldu að minnsta kosti einn notanda',
            },
        },
        permission: {
            header: 'Heimildir',
            label: {
                module: 'Eining',
                subModule: 'Undireining',
                action: 'Aðgerð',
            },
        },
    },
    transactions: {
        headerTitle: 'Færslur ökumanns - ##COMPANY_BRAND_NAME## : Hraðhleðsla bíla í Bretlandi',
        title: 'Færslur ökumanns',
        transaction: 'Færsla',
        columns: {
            amount: 'Upphæð',
            location: 'Staðsetning',
            date: 'Dagsetning',
            milesAdded: 'Mílum bætt við',
            time: 'Tími',
            cost: 'Kostnaður',
            energy: 'Orka',
            action: 'Aðgerð',
            remark: 'Athugasemdir',
            credit: 'Kredit',
            debit: 'Debet',
            closing: 'Lokar',
            transaction: 'Auðkenni færslu',
            name: 'Nafn',
            type: 'Gerð',
            federatedAccount: 'Gerð stofnanaaðgangs',
            reference_id: 'Tilvísunarnúmer',
            energyCost: 'Orkukostnaður',
            fixedCost: 'Fastur kostnaður',
            chargingTimeCost: 'Hleðslutímakostnaður',
            parkingTime: 'Biðtími bílastæðis',
            parkingCost: 'Bílastæðakostnaður',
            appliedTariff: 'Beitt Gjaldskrá',
            netCost: 'Nettókostnaður',
            VATRate: ' VSK-hlutfall',
        },
        form: {
            charge: 'Er að hlaða',
            payment: 'Greiðsla',
            month: 'Mánuður',
        },
        label: {
            exportAll: 'Flytja allt út',
            driver: 'Ökumaður',
            vehicle: 'Bifreið',
            cardPayment: 'Kortagreiðsla',
            referralBonus: 'Tilvísunarbónus',
            rewards: 'Umbun',
            transactionDetails: 'Upplýsingar um færslu',
            transaction_id: 'Auðkenni færslu',
            fullName: 'Fullt nafn',
            email: 'Netfang',
            phone_number: 'Símanúmer',
            viewFailedPayments: 'Skoða misheppnaðar greiðslur',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            back: 'Til baka',
        },
        placeholder: {
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
            name: 'Nafn',
            chargingStation: 'Hleðslustöð',
            selectType: 'Velja gerð',
            transaction: 'Auðkenni færslu',
            reference_id: 'Tilvísunarnúmer',
        },
        message: {
            noDataToExport: 'Engin gögn til staðar til að flytja út.',
            error: {
                common: 'Eitthvað fór úrskeiðis. Vinsamlega reyndu aftur',
            },
        },
    },
    driver: {
        title: 'Ökumenn : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Ökumenn',
        manageDriver: 'Stjórna ökumönnum',
        startCharge: 'Hefja fjarhleðslu',
        activities: 'Aðgerðir',
        detail: 'Upplýsingar ökumanns',
        address_detail: 'Heimilisfang',
        billing_address_detail: 'Reikningsfang',
        chargeDetails: 'Hleðsluupplýsingar',
        debtLetterHistory: 'Innheimtusaga',
        note: 'Athugið: Ef fyrri umbun ökumanns er ekki hin sama og í nýrri kynningu falla núverandi volt hans niður.',
        charityAdded: 'Gjöfum til góðgerðarmála bætt við',
        cd: 'cd',
        placeholder: {
            name: 'Nafn',
            email: 'Netfang',
            firstName: 'Skírnarnafn',
            lastName: 'Föðurnafn',
            payment_card: 'Seinustu 4 stafir greiðslukorts',
            select: {
                status: 'Velja stöðu',
                account_type: 'Veldu gerð aðgangs',
                payment_type: 'Veldu gerð greiðslu',
                driver_groups: 'Veldu bílstjórahópa',
                driver_tags: 'Veldu merki',
                organization: 'Veldu stofnun',
                promotion: 'Veldu kynningu',
            },
            driverGroup: 'Bílstjórahópar',
            organization: 'Stofnun',
            account_type: 'Reikningstegund',
            payment_type: 'Greiðslutegund',
            referral_code: 'Tilvísunarkóði',
            driver_tags: 'Merki',
            address: 'Heimilisfang 1',
            address2: 'Heimilisfang 2',
            city: 'Borg',
            county: 'Hérað',
            postal_code: 'Póstnúmer',
            billing_address: 'Heimilisfang 1',
            billing_address2: 'Heimilisfang 2',
            billing_city: 'Borg',
            billing_county: 'Hérað',
            billing_postal_code: 'Póstnúmer',
            promotion: 'Kynningar',
            currentDriverPromotion: 'Núverandi kynning',
            driverPromotionJoinDate: 'Dagsetning skráningar',
            chargeLocation: 'Staðsetning',
            chargeStation: 'Stöð',
            connector: 'Tengi',
            limitedKWH: 'Takmarkað kWh:',
            confirmationNote:
                'Vinsamlega staðfestu skírnarnafn, föðurnafn, heimilisfang 1 og póstnúmer áður en fjarhleðsla er ræst til að tryggja öryggi aðgangs. Vinsamlega hakið í reitinn eftir að viðskiptavinur hefur staðfest',
            rfidCard: 'RFID-kort',
            confirmationNoteFleet: 'Vinsamlega staðfestu þetta lykilorð við bílstjórann:',
            vehicle_number: 'Númer ökutækis',
            api_url: 'API-hlekkur',
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
            publicRFID: 'Almennt auðkenni RFID-korts',
            languagePreference: 'Valið tungumál',
            searchAddress: 'Heimilisfang',
        },
        label: {
            firstName: 'Skírnarnafn',
            lastName: 'Föðurnafn',
            email: 'Netfang',
            group: 'Hópur',
            driverGroups: 'Bílstjórahópar',
            driver_tags: 'Merki',
            organization: 'Stofnun',
            payment_type: 'Greiðslutegund',
            referral_code: 'Tilvísunarkóði',
            createdDate: 'Stofndags.',
            id: 'Auðkenni',
            action: 'Aðgerð',
            status: 'Staða',
            account_type: 'Reikningstegund',
            type: 'Gerð',
            name: 'Nafn',
            delete: 'Eyða',
            enable: 'Virkja',
            all: 'Allt',
            disable: 'Afvirkja',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            cancelled: 'Hætt við',
            deleted: 'Eytt',
            address: 'Heimilisfang',
            address2: 'Heimilisfang 2',
            city: 'Borg',
            county: 'Hérað',
            postal_code: 'Póstnúmer',
            billing_address: 'Heimilisfang 1',
            billing_address2: 'Heimilisfang 2',
            billing_city: 'Borg',
            billing_county: 'Hérað',
            billing_postal_code: 'Póstnúmer',
            promotion: 'Kynningar',
            expired: '- Útrunnið',
            currentDriverPromotion: 'Núverandi kynning',
            driverPromotionJoinDate: 'Dagsetning skráningar',
            vehicleNumber: 'Númer ökutækis',
            paymentCard: 'Greiðslukort',
            cardType: 'Kortategund',
            cardNumber: 'Kortanr. (Seinustu 4 stafir)',
            cardTitle: 'Titill korts',
            cardExpiry: 'Gildistími korts',
            paymentServiceProvider: 'Þjónustuaðili greiðslu',
            viewReferral: 'Skoða tilvísun',
            referralDetails: 'Upplýsingar tilvísunar',
            referrer_name: 'Nafn tilvísanda',
            referral_name: 'Tilvísunarnafn',
            referral_bonus: 'Tilvísunarbónus',
            referralBonusStatus: 'Staða tilvísunarbónuss',
            referee_Name: 'Nafn móttökuaðila tilvísunar',
            noRecords: 'Engar skrár til birtingar',
            noReferralsMessage: 'Engin tilvísun',
            referrerName: 'Nafn tilvísanda þess sem tók við tilvísun:',
            referralCode: 'Kóði þess sem tók við tilvísun:',
            noReferrerMessage: 'Engin tilvísandi',
            current_balance: 'Núverandi innistæða',
            referral_balance: 'Inneign tilvísunar',
            account_balance: 'Reikningsstaða',
            rewards_balance: 'Umbunarstaða',
            balanceDetails: 'Upplýsingar um stöðu',
            pending_transactions_details: 'Upplýsingar um Ólokin Viðskipti',
            pending_balance: 'Ólokið Eftirstöðvar',
            federated_account_type: 'Gerð stofnanaaðgangs',
            pending: 'Í bið',
            rfidCard: 'RFID-kort',
            startCharge: 'Hefja fjarhleðslu',
            chargeLocation: 'Staðsetning',
            chargeStation: 'Stöð',
            connector: 'Tengi',
            limitedKWH: 'Takmarkað kWh:',
            confirmationNote:
                'Vinsamlega staðfestu skírnarnafn, föðurnafn, heimilisfang 1 og póstnúmer áður en fjarhleðsla er ræst til að tryggja öryggi aðgangs. Vinsamlega hakið í reitinn eftir að viðskiptavinur hefur staðfest',
            fullName: 'Fullt nafn',
            phoneNo: 'Símanúmer',
            confirmationNoteFleet: 'Vinsamlega staðfestu þetta lykilorð við bílstjórann:',
            chargingStartedMessage: 'Tókst að óska eftir fjarhleðslu',
            resetPassword: 'Endurstilla lykilorð',
            password: 'Lykilorð',
            disablePaymentCard: 'Afvirkja greiðslukort',
            requestedData: 'Umbeðin gögn',
            apiURL: 'API',
            viewData: 'Skoða gögn',
            deletionEmailSent: 'Tölvupóstur sendur um að eyða',
            yes: 'Já',
            onstop: 'Við stöðvun',
            badDebtor: 'Slæmur skuldari',
            available: 'Í boði',
            languagePreference: 'Valið tungumál',
            fakeAccount: 'Gerviaðgangur',
            addNotes: 'Bæta við athugasemdum',
            newNote: 'Ný athugasemd',
            addNote: 'Bæta við athugasemd',
            existingNotes: 'Núverandi athugasemdir',
            viewNotes: 'Skoða athugasemdir',
            notes: 'Athugasemdir',
            financialDetails: 'Fjármálaupplýsingar',
            uniqueID: 'Einkvæmt auðkenni',
            dateGenerated: 'Búin til dags.',
            debtValue: 'Skuldarvirði',
            letterTemplate: 'Bréfsniðmát notað',
            lastCardValidationDate: 'Dagsetn. síðustu kortaauðkenningar',
            cancelPendingTransactions: 'Hætta Við Óafgreiddar Færslur',
            cancelTransactions: 'Hætta Við Færslur',
        },
        pendingTransaction: {
            label: {
                chargeLocation: 'Staðsetning',
                chargeStation: 'Hleðslustöð',
                sessionId: 'Setuauðkenni',
                sessionStatus: 'Staða Lota',
                amount: 'Upphæð',
                createdDate: 'Búin Til Dagsetning',
            },
            button: {
                settle: 'Gjalda',
                cancel: 'Hætta Við',
            },
        },
        account_type: {
            driver: 'Ökumaður',
            vehicle: 'Bifreið',
        },
        payment_type: {
            credit_account: 'Inneignaraðgangur',
            prepayment_account: 'Fyrirframgreiddur aðgangur',
        },
        button: {
            search: 'Leita',
            cancel: 'Hætta við',
            save: 'Vista',
            edit: 'Breyta',
            reset: 'Endurstilla',
            delete: 'Eyða',
            yes: 'Já',
            no: 'Nei',
            enabled: 'Virkja',
            disabled: 'Afvirkja',
            action: 'Aðgerð',
            back: 'Til baka',
            sendEmail: 'Senda tölvupóst',
            viewTransactions: 'Skoða færslur',
            close: 'Loka',
            startCharge: 'Hefja fjarhleðslu',
            startChargeBtn: 'Hefja hleðslu',
            resetPassword: 'Endurstilla lykilorð',
            submit: 'Senda',
            amendBalance: 'Loka inneign',
            viewActivities: 'Skoða aðgerðir',
            premiumSubscriptions: 'Premium-áskriftir',
            markAsFake: 'Merkja sem gerviaðgang',
            addNotes: 'Bæta við athugasemdum',
            debtLetterHistory: 'Innheimtusaga',
            enableReferralCode: 'Virkja tilvísunarkóða',
            disableReferralCode: 'Afvirkja tilvísunarkóða',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
            sendMailConfirmMessage: 'Ertu viss um að þú viljir senda tölvupóst?',
            mailSentSuccessMessage: 'Tókst að senda tölvupóst.',
            resetPasswordConfirmMesage: 'Ertu viss um að þú viljir endurstilla lykilorð fyrir þennan notanda?',
            deleteDriverConfirmMesage: 'Ertu viss um að þú viljir eyða aðgangi þessa ökumanns?',
            markAsFakeConfirmMessage:
                'Þetta er óafturkræft ferli sem hreinsar upplýsingar. Viltu merkja aðgang þessa ökumanns sem gerviaðgang?',
            enableReferralCodeConfirmMesage: 'Ertu viss um að þú viljir virkja tilvísunarkóða fyrir þennan ökumann?',
            disableReferralCodeConfirmMesage:
                'Ertu viss um að þú viljir slökkva á tilvísunarkóða fyrir þennan ökumann?',
            cancelPendingTransactionsConfirmMesage: 'Ertu viss um að þú viljir hætta við valdar óafgreiddar færslur?',
        },
        errors: {
            driverGroups: {
                required: 'Vinsamlega veldu að minnsta kosti einn bílstjórahóp',
            },
            organization: {
                required: 'Vinsamlega veldu stofnun',
            },
            tag: {
                invalid_fromat: 'Ógildir stafir í merki',
            },
            fullName: {
                valid: 'Vinsamlega sláðu inn gilt nafn',
            },
            phoneNo: {
                match: 'Vinsamlega sláðu inn gilt símanúmer',
            },
            email: {
                required: 'Vinsamlega sláðu inn netfang',
                email: 'Vinsamlega sláðu inn gilt netfang.',
            },
            password: {
                passwordFormat:
                    'Lykilorð verður að vera yfir 10 stafir og innihalda að minnsta kosti einn hástaf, einn lágstaf, sérstaf og tölustaf.',
            },
        },
    },
    driverGroup: {
        title: 'Bílstjórahópar : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        titleFleet: 'Hópar : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        manageDriverGroup: 'Sjá um bílstjórahópa',
        manageDriverGroupFleet: 'Sjá um hóp',
        driversList: 'Ökumenn',
        driversListFleet: 'Ökumenn/bifreiðar',
        header: 'Bílstjórahópar',
        headerFleet: 'Hópar',
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            edit: 'Breyta',
            delete: 'Eyða',
            save: 'Vista',
            cancel: 'Hætta við',
            yes: 'Já',
            no: 'Nei',
            action: 'Aðgerð',
            add: 'Bæta við',
            back: 'Til baka',
            enable: 'Virkja',
            disable: 'Afvirkja',
        },
        placeholder: {
            groupName: 'Notendahópur',
            drivers: 'Velja bílstjóra',
            driversFleet: 'Velja bílstjóra/bifreiðar',
            select: 'Velja stöðu',
            selectType: 'Velja gerð',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
        },
        label: {
            id: 'Auðkenni',
            name: 'Nafn',
            description: 'Lýsing',
            organization: 'Stofnun',
            createdBy: 'Búið til af',
            status: 'Staða',
            modifiedBy: 'Breytt af',
            createdDate: 'Stofndags.',
            modifiedDate: 'Dagsetning breytingar',
            action: 'Aðgerð',
            groupName: 'Notendahópur',
            delete: 'Eyða',
            enable: 'Virkja',
            disable: 'Afvirkja',
            phoneNo: 'Símanúmer',
            email: 'Netfang',
            groupAccess: 'Aðgangur hóps',
            selectDrivers: 'Velja bílstjóra',
            selectDriversFleet: 'Velja bílstjóra/bifreiðar',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            yes: 'Já',
            no: 'Nei',
            vehicle_number: 'Nr, ökutækis',
            type: 'Gerð',
            updateDriverAssociation: 'Uppfæra tengingu bílstjóra',
            addToThisGroup: 'Bæta við þennan hóp',
            cancel: 'Hætta við',
        },
        form: {
            groupName: {
                label: 'Notendahópur',
                placeholder: 'Sláðu inn notendahóp',
            },
            description: {
                label: 'Lýsing',
                placeholder: 'Sláðu inn lýsingu',
            },
        },
        errors: {
            groupName: {
                required: 'Vinsamlega sláðu inn nafn hóps',
                valid: 'Vinsamlega sláðu inn gilt nafn hóps',
                max: 'Hámark 50 stafir',
            },
            description: {
                max: 'Hámark 255 stafir',
            },
            driverList: {
                required: 'Vinsamlega veldu að minnsta kosti einn bílstjóra',
                requiredfleet: 'Vinsamlega veldu að minnsta kosti einn bílstjóra/bifreið',
            },
            spendLimit: {
                valid: 'Vinsamlega veldu að minnsta kosti ein gild eyðslumörk',
            },
        },
    },
    vat: {
        title: 'VSK : ##COMPANY_BRAND_NAME##',
        vat: 'VSK',
        manageVat: 'Sjá um VSK',
        label: {
            name: 'Nafn',
            description: 'Lýsing',
            rate: 'Gjald',
            createdDate: 'Stofndags.',
            action: 'Aðgerð',
            status: 'Staða',
            disabled: 'Óvirkt',
            enabled: 'Virkt',
            delete: 'Eyða',
            enable: 'Virkja',
            disable: 'Afvirkja',
            defaultVAT: 'Staðlaður VSK',
            yes: 'Já',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
            setDefaultConfirmMesage: 'Ertu viss um að þú viljir stilla þennan VSK sem staðal?',
        },
        button: {
            search: 'Leita',
            cancel: 'Hætta við',
            save: 'Vista',
            add: 'Bæta við',
            edit: 'Breyta',
            reset: 'Endurstilla',
            delete: 'Eyða',
            enabled: 'Virkja',
            disabled: 'Afvirkja',
            action: 'Aðgerð',
            back: 'Til baka',
            setDefaultVAT: 'stilla sem staðlað',
        },
        placeholder: {
            select: 'Velja stöðu',
            name: 'Nafn',
            description: 'Lýsing',
            rate: 'Gjald',
        },
        errors: {
            name: {
                valid: 'Sláðu inn gilt nafn',
            },
            rate: {
                max: 'Gjald má ekki vera meira en 100',
                min: 'Gjald má ekki vera minna en 0',
                number: 'Gjald verður að vera tölustafir',
            },
            description: {
                valid: 'Sláðu inn gilda lýsingu',
            },
        },
    },
    confirmBox: {
        button: {
            yes: 'Já',
            no: 'Nei',
            proceed: 'Halda áfram',
            cancel: 'Hætta við',
        },
    },
    tag: {
        title: 'Merki : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        tag: 'Merki',
        manageUser: 'Sjá um notendur',
        placeholder: {
            name: 'Heiti merkis',
            select: 'Velja',
        },
        label: {
            name: 'Heiti merkis',
            driver_count: 'Fjöldi bílstjóra',
            charge_location_count: 'Breyta fjölda staða',
            action: 'Aðgerð',
            delete: 'Eyða',
            editHeader: 'Breyta merki',
        },
        button: {
            search: 'Leita',
            cancel: 'Hætta við',
            save: 'Vista',
            add: 'Bæta við',
            edit: 'Breyta',
            reset: 'Endurstilla',
            delete: 'Eyða',
            yes: 'Já',
            no: 'Nei',
            enabled: 'Virkja',
            disabled: 'Afvirkja',
            action: 'Aðgerð',
            back: 'Til baka',
        },
        message: {
            deleteConfirmMesage:
                'Merki verður eytt frá öllum tengdum bílstjórum og hleðslustöðum. Ertu viss um að þú viljir eyða?',
        },
        errors: {
            name: 'Ógildir stafir í merki',
        },
    },
    chargeStation: {
        title: 'Hleðslustöðvar : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        chargeStations: 'Hleðslustöðvar',
        manageVat: 'Sjá um hleðslustöð',
        label: {
            modifiedDate: 'Dagsetning breytingar',
            importChargeStationHeader: 'Flytja inn hleðslustöð',
            csvFile: 'CSV-skrá',
            manageAmenities: 'Sjá um þjónustu',
            chargePoint: 'Hleðslustaður',
            allLocations: 'Allar staðsetningar',
            assignedLocation: 'Úthlutaðar staðsetningar',
            unassignedLocation: 'Óúthlutaðar staðsetningar',
            chargeLocation: {
                cp_id: 'CP-auðkenni',
                type: 'Gerð',
                name: 'Nafn',
                locationName: 'Heiti staðsetningar',
                address: 'Heimilisfang',
                city: 'Borg',
                postal_code: 'Póstnúmer',
                appliesToOrg: 'Á við um stofnun',
                associatedPromotion: 'Tengd kynning',
                gmbLocationId: 'GMB-staðarauðkenni',
                override_tariff: 'Hnekkja gjaldi',
                cpo: 'CPO',
            },
            chargeStation: {
                uid: 'Uld',
                evse_id: 'EVSE-auðkenni',
                status: 'Staða',
                physicalReference: 'Áþreifanleg tilvísun',
                city: 'Borg',
                postal_code: 'Póstnúmer',
            },
            stationConnector: {
                connector_id: 'Auðkenni tengils',
                standard: 'Staðall',
                format: 'Sníða sem gerð',
                power_type: 'Rafmagnstegund',
                voltage: 'Rafspenna',
                amperage: 'Straumstyrkur',
                power_rating: 'Afköst',
                override_tariff: 'Hnekkja gjaldi',
            },
            selectTag: 'Velja merki',
            addTagHeader: 'Tengja merki',
            tags: 'Merki',
            yes: 'Já',
            assignedTariff: 'Setja gjaldskrá',
            assignTariff: 'Setja gjaldskrá á stað',
            delete: 'Eyða',
            action: 'Aðgerð',
            addPromotion: 'Bæta við kynningu',
            selectPromotion: 'Velja kynningu',
            exportChargeStations: {
                connector_id: 'connector_id',
                max_power: 'max_power',
                cp_id: 'cp_id',
                type: 'gerð',
                location: 'staðsetning',
                station_name: 'station_name',
                address: 'heimilisfang',
                city: 'borg',
                postal_code: 'postal_code',
                country: 'land',
                latitude: 'breiddargráða',
                longitude: 'lengdargráða',
                evse_id: 'evse_id',
                standard: 'staðall',
                format: 'sniðmát',
                powertype: 'rafmagnstegund',
                voltage: 'rafspenna',
                amperage: 'straumstyrkur',
            },
            gmbLocationID: 'GMB-staðarauðkenni',
            clickHere: 'Smelltu hér',
            downloadTemplate: 'til að hlaða niður sniðmáti',
            importStationsModel: 'Flytja inn hleðslustöðvarlíkan',
            noDataToExport: 'Engin gögn til staðar til að flytja út.',
            note: 'Athugið:',
            autoCalculateMaxPowerNote:
                'Sum CPO hafa verið stillt til að reikna sjálfkrafa út hámarksafköst. Með því að nota þennan innflutning gætu þessir útreikningar glatast.',
            applyToOrg: 'Bæta við allar stofnanir',
        },
        errors: {
            tag: {
                invalid_fromat: 'Ógildir stafir í merki',
            },
            file: {
                fileType: 'Hægt er að hlaða upp skrár með „.csv“-skráarheiti',
            },
            gmbLocationId: {
                valid: 'Sláðu inn gilt GMB- staðarauðkenni',
            },
            common: 'Eitthvað fór úrskeiðis. Vinsamlega reyndu aftur',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            save: 'Vista',
            cancel: 'Hætta við',
            edit: 'Breyta',
            expand: 'Stækka',
            collapse: 'Minnka',
            import: 'Flytja inn',
            synchronize: 'Samstilla',
            syncStation: 'Samstilla stöð',
            assignTariff: 'Setja gjaldskrá',
            delete: 'Eyða',
            add: 'Bæta við',
            addSelected: 'Bæta við völdu',
            addAll: 'Bæta við öllu',
            yes: 'Já',
            no: 'Nei',
            back: 'Til baka',
            apply: 'Bæta við',
            editGMBLocationID: 'Breyta GMT-staðarauðkenni',
            downloadLocationsData: 'Draga út gögn um hleðslustaði',
            exportAll: 'Flytja allt út',
            importStationsModel: 'Flytja inn hleðslustöðvarlíkan',
            deleteSelected: 'Eyða völdu',
            export: 'Flytja út',
            viewAssociatedTariffs: 'Skoða tengd gjöld',
        },
        placeholder: {
            selectStationStatus: 'Velja stöðu',
            name: 'Nafn',
            cp_id: 'CP-auðkenni',
            tags: 'Merki',
            address: 'Heimilisfang',
            selectTag: 'Veldu merki',
            evse_id: 'EVSE-auðkenni',
            selectChargePoint: 'Veldu CPO',
            selectPromotion: 'Velja kynningu',
            gmbLocationID: 'GMB-staðarauðkenni',
            selectPowerType: 'Veldu rafmagnstegund',
            selectRegion: 'Veldu svæði',
            selectAppliedTariff: 'Veldu Notað Gjaldskrá',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            addPromotion: 'Tókst að uppfæra upplýsingar um kynningu',
            updateAmenitiesSuccess: 'Tókst að uppfæra þjónustu hleðslustaða',
            chargePointRequire: 'Nauðsynlegt er að hafa að minnsta kosti einn hleðslustað',
            deleteBulkConfirmMessage: 'Ertu viss um að þú viljir eyða völdum skrám?',
            applyToAllOrgConfirmMessage: 'Viltu bæta þessari gjaldskrá við stofnanir auk allra staða?',
        },
        manageAmenities: 'Sjá um þjónustu',
        chargeStationTariffDetailsModal: {
            header: 'Gjaldskrárupplýsingar',
            tabsName: {
                general: 'Almennt',
            },
        },
    },
    chargeStationMap: {
        title: 'Kort hleðslustöðva : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Hleðslustöðvar',
        label: {
            address: 'Heimilisfang',
            backOfficeUrl: 'Bakvinnsluhlekkur :',
            amenities: 'Þjónustur :',
            satellite: 'Gervihnöttur',
            map: 'Kort',
            search: 'Leita',
            refresh: 'Endurnýja',
            apply: 'Bæta við',
            clear: 'Hreinsa',
            loading: 'Er að hlaða...',
        },
        placeholder: {
            locationSearch: 'Leita að stöð',
            mapSearch: 'Leita eftir götuheiti, borg eða póstnúmeri',
        },
    },
    promotionsRequest: {
        headerTitle: 'Kynningarbeiðnir bílstjóra : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        title: 'Kynningarbeiðnir bílstjóra',
        promotionsRequest: 'Umbeðnar kynningar',
        columns: {
            driverName: 'Nafn bílstjóra',
            promotionsName: 'Nafn kynningar',
            promotionsCode: 'Kóði',
            approved: 'Staða',
            approvedBy: 'Breytt af',
            approvedDate: 'Dagsetning breytingar',
            action: 'Aðgerð',
            email: 'Netfang',
        },
        form: {
            charge: 'Er að hlaða',
            payment: 'Greiðsla',
            month: 'Mánuður',
        },
        label: {
            approved: 'Samþykkt',
            pending: 'Í bið',
            rejected: 'Hafnað',
            modelHeader: 'Umbeðin kynning -',
            enterComment: 'Sláðu inn athugasemdirnar þínar',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            back: 'Til baka',
            approved: 'Samþykkja',
            pending: 'Í bið',
            rejected: 'Hafna',
            action: 'Aðgerð',
            edit: 'Breyta',
        },
        placeholder: {
            driverName: 'Nafn bílstjóra',
            promotionsName: 'Nafn kynningar',
            promotionsCode: 'Kóði',
            select: 'Velja stöðu',
        },
        message: {
            ManagestatusMesage:
                'Smelltu á Samþykkt eða Hafnað til að virkja beiðnistöðu. Þegar þessi beiðni hefur verið uppfærð er ekki lengur hægt að breyta henni.',
        },
    },
    driverAccountBalance: {
        title: 'Reikningsstaða bílstjóra : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        driverAccountBalance: 'Reikningsstaða bílstjóra',
        manageUser: 'Sjá um reikningsstöðu bílstjóra',
        placeholder: {
            name: 'Nafn/netfang',
            select: 'Velja stöðu',
            payment_type: 'Veldu gerð greiðslu',
            description: 'Athugasemd',
            amount: 'Sláðu inn kredit-/debetupphæð',
        },
        label: {
            name: 'Nafn',
            email: 'Netfang',
            payment_type: 'Greiðslutegund',
            driver_status: 'Staða aðgangs',
            current_balance: 'Upphæð',
            currency: 'Gjaldmiðill',
            driver_id: 'Auðkenni ökumanns',
            action: 'Aðgerð',
            delete: 'Eyða',
            refundHeader: 'Úttekt',
            creditPayment: 'Inneignaraðgangur',
            prePayment: 'Fyrirframgreiddur aðgangur',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            refund: 'Breyta reikningsstöðu',
            description: 'Athugasemd',
            amount: 'Sláðu inn kredit-/debetupphæð',
            additional_payment: 'Viðbótargreiðsla',
            payment_refunds: 'Greiðsluúttektir',
            payment_settlement: 'Breyting inneignar - beiðni',
            balance: 'Gerð inneignar',
            accountBalance: 'Inneign aðgangs',
            referralBonus: 'Tilvísunarbónus',
            rewardBalance: 'Umbunarstaða',
            total_balance: 'Heildarstaða',
            rewards: 'Umbun',
            pendingBalance: 'Ólokið Eftirstöðvar',
        },
        button: {
            search: 'Leita',
            cancel: 'Hætta við',
            save: 'Vista',
            add: 'Bæta við',
            edit: 'Breyta',
            reset: 'Endurstilla',
            delete: 'Eyða',
            yes: 'Já',
            no: 'Nei',
            enabled: 'Virkja',
            disabled: 'Afvirkja',
            action: 'Aðgerð',
            back: 'Til baka',
            send_for_approval: 'Senda til samþykkis',
        },
        message: {
            deleteConfirmMesage:
                'Merki verður eytt frá öllum tengdum bílstjórum og hleðslustöðum. Ertu viss um að þú viljir eyða?',
        },
        errors: {
            name: 'Ógildir stafir í merki',
            amount: {
                moreThan: 'Upphæð verður að vera meiri/minni en 0',
                maxcredit: 'Hámarki kreditaðgangs náð',
                maxdebit: 'Hámarki debetaðgangs náð',
            },
        },
    },
    driverPromotions: {
        title: 'Sjá um kynningu : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        manageDriverPromotion: 'Sjá um kynningu',
        driverPromotions: 'Kynningar',
        label: {
            name: 'Nafn',
            code: 'Kóði',
            errorMessage: 'Villuskilaboð',
            used: 'Notað',
            unUsed: 'Ónotað',
            uploadFileErrorMessage: 'Villa kom upp við að hlaða upp kynningarkóðum.',
            updatePromotionCode: 'Uppfæra kynningarkóða',
            unique_code: 'Einkvæmur kóði',
            uniquePromotionCode: 'Kynningarkóðar',
            importDriverPromotionCodeHeader: 'Flytja inn kynningarkóða ökumanns',
            csvFile: 'Kynningarkóðar',
            promotionCode: 'Kynningarkóði',
            usedBy: 'Notað af',
            description: 'Lýsing',
            accountCredit: 'Inneign aðgangs',
            discountRatePeriod: 'Afsláttartímabil',
            indays: '(Dagar)',
            intilakWhRate: 'kWh gjald við upphaf',
            ivRewardsPromotion: 'IV umbunarkynning',
            referralPromotion: 'Tilvísunarkynning',
            expiryDate: 'Fyrningardagsetning',
            needApprovalToJoinPromotion: 'Leyfi þarf til að taka þátt í kynningu',
            newDriversOnly: 'Aðeins nýir bílstjórar',
            forOrganisation: 'Handa stofnun',
            createdDate: 'Stofndags.',
            action: 'Aðgerð',
            status: 'Staða',
            delete: 'Eyða',
            enable: 'Virkja',
            disable: 'Afvirkja',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            deleted: '(Eytt)',
            csvFileSupported: 'Aðeins CSV skrár eru studdar',
            clickHere: 'Smelltu hér',
            downloadTemplate: 'til að hlaða niður sniðmáti',
            exportColumnHeder: 'promotion_codes',
            min_kwh_package_promotion: 'Lágmarks kWh',
            package_promotion_period: 'Kynningatímabil pakkningar (Dagar)',
            package_promotion_volt_bonus: 'Umbunað fyrir fjölda Volta',
            rfidCardUnitPrice: 'Einingarverð RFID-korts',
            subscription: 'Premium-áskrift',
            tariffUpdate: 'Uppfærsla gjaldskrár',
            currentTariff: 'Núverandi yfirskrifgjaldskrá',
            next: 'Næsta',
            newTariff: 'Ný yfirskrifgjaldskrá',
            save: 'Vista',
            override_tariff: 'Hnekkja gjaldi',
            manageOverrideTariff: 'Stjórna Yfirtökugjaldi',
        },
        placeholder: {
            name: 'Nafn',
            promotionCode: 'Kynningarkóði',
            selectTariff: 'Velja gjaldskrá',
            selectStatus: 'Velja stöðu',
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
            forOrganisation: 'Handa stofnun',
            min_kwh_package_promotion: 'Lágmarks kWh',
            package_promotion_period: 'Kynningatímabil pakkningar',
            package_promotion_volt_bonus: 'Umbunað fyrir fjölda Volta',
            rfidCardUnitPrice: 'Einingarverð RFID-korts',
            premium_subscription: 'Premium-áskrift',
            selectCurrentTariff: 'Veldu núverandi yfirskrifgjaldskrá',
            selectNewTariff: 'Veldu nýja yfirskrifgjaldskrá',
            selectOverrideTariff: 'Veldu Yfirtökugjaldskrá',
        },
        button: {
            update: 'Uppfæra',
            import: 'Flytja inn',
            search: 'Leita',
            cancel: 'Hætta við',
            save: 'Vista',
            add: 'Bæta við',
            edit: 'Breyta',
            reset: 'Endurstilla',
            delete: 'Eyða',
            enable: 'Virkja',
            disable: 'Afvirkja',
            action: 'Aðgerð',
            back: 'Til baka',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
            subscriptionChangeWarningMessage:
                'Viðvörun: Með því að breyta gerð áskriftar er hætt við allar sjálfvirkar endurnýjanir tengds bílstjóra.',
            tariffUpdateNote: 'Nýrri gjaldskrá verður úthlutað til eftirfarandi kynninga:',
            updateTariffConfirmMessage: 'Ertu viss um að þú viljir uppfæra gjaldskrá valinna kynninga?',
            selectOneRecord: 'Vinsamlega veldu að minnsta kosti eina kynningu til að uppfæra gjaldskrá',
        },
        errors: {
            promotionName: {
                valid: 'Sláðu inn gilt nafn kynningar',
            },
            promotionCode: {
                valid: 'Sláðu inn gildan kynningarkóða',
            },
            accountCredit: {
                moreThan: 'Reikningsinneign verður að vera meira en 0',
                max: 'Hámarki kreditaðgangs náð',
                typeError: 'Sláðu inn gilda inneignarupphæð aðgangs',
            },
            discountRatePeriod: {
                moreThan: 'Afsláttartímabil verður að vera meira en 0',
            },
            intialRate: {
                max: 'Gjald má ekki vera meira en 100',
                min: 'Gjald má ekki vera minna en 0',
                typeError: 'Sláðu inn gilt gjald',
            },
            common: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
            file: {
                fileType: 'Hægt er að hlaða upp skrár með „.csv“-skráarheiti',
            },
            maxValue: 'Hámarksgildi má ekki vera hærra en 2147483647',
            rfidCardUnitPrice: {
                max: 'Einingarverð RFID-korts má ekki vera meira en 1000',
            },
        },
    },
    paymentApproval: {
        headerTitle: 'Samþykktir reikningsstöðu - ##COMPANY_BRAND_NAME## Hraðhleðsla bíla í Bretlandi',
        title: 'Samþykktir reikningsstöðu',
        transaction: 'Færsla',
        columns: {
            email: 'Netfang',
            amount: 'Upphæð',
            status: 'Staða',
            request_by: 'Umbeðið af',
            request_date: 'Beðið um þann',
            request_by_comment: 'Umbeðið af athugasemdum',
            review_by: 'Yfirfarið af',
            review_date: 'Yfirfarið þann',
            review_comment: 'Athugasemdir umsagnaraðila',
            credit: 'Kredit',
            debit: 'Debet',
            closing: 'Lokar',
            transaction: 'Auðkenni færslu',
            name: 'Nafn',
            action: 'Aðgerð',
            request_type: 'Gerð beiðni',
            invoice: 'Reikningur',
        },
        form: {
            driver: 'Ökumaður',
            organisation: 'Stofnun',
            month: 'Mánuður',
        },
        label: {
            request_type: 'Gerð beiðni',
            refundHeader: 'Breyting inneignar',
            pending: 'Í bið',
            approved: 'Samþykkja',
            declined: 'Hafna',
            approve: 'Samþykkja',
            decline: 'Hafna',
            comment: 'Sláðu inn athugasemdirnar þínar',
            status: 'Staða',
            refund: 'Samþykkja kredit/debet',
            refundAmount: 'Upphæð úttektar',
            commentsFrom: 'Athugasemdir frá',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            back: 'Til baka',
            save: 'Vista',
            cancel: 'Hætta við',
        },
        placeholder: {
            comment: 'Sláðu inn athugasemdirnar þínar',
            status: 'Velja stöðu',
            name: 'Nafn/netfang',
            refundAmount: 'Upphæð úttektar',
        },
        message: {
            noDataToExport: 'Engin gögn til staðar til að flytja út.',
            selectApprovalOrReject: 'Vinsamlega samþykkið/hafnið þessari beiðni',
        },
    },
    paymentScheduleSetting: {
        title: 'Stillingar greiðsluáætlunar : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Greiðsluáætlun',
        note: 'Skipuleggðu bakgrunnsstarf til að hreinsa eftirstandandi reikninga fyrir EV-hleðslu bílstjóra',
        placeholder: {
            day_of_week: 'Vikudagur',
        },
        label: {
            daily: 'Daglega',
            weekly: 'Vikulega',
            day_of_week: 'Vikudagur',
            selectDay: 'Veldu dag',
        },
        day_of_week: {
            monday: 'MÁNUDAGUR',
            tuesday: 'ÞRIÐJUDAGUR',
            wednesday: 'MIÐVIKUDAGUR',
            thursday: 'FIMMTUDAGUR',
            friday: 'FÖSTUDAGUR',
            saturday: 'LAUGARDAGUR',
            sunday: 'SUNNUDAGUR',
        },
        button: {
            save: 'Vista',
        },
    },
    paymentFailures: {
        title: 'Misheppnaðar greiðslur : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        managePaymentFailures: 'Misheppnaðar greiðslur',
        placeholder: {
            name: 'Nafn/netfang',
            note: 'Athugasemd',
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
            select: 'Velja stöðu',
            status: 'Veldu stöðu',
            failureReason: 'Ástæða höfnunar',
        },
        label: {
            name: 'Nafn',
            email: 'Netfang',
            transaction_id: 'Auðkenni færslu',
            total_amount: 'Heildarupphæð',
            currency_name: 'Gjaldmiðill',
            created_date: 'Stofndags.',
            status: 'Staða',
            note: 'Athugasemd',
            action: 'Aðgerð',
            editHeader: 'Uppfæra greiðslustöðu',
            pending: 'Í bið',
            acknowledged: 'Viðurkennt',
            closed: 'Lokað',
            transactionDetails: 'Upplýsingar um færslu',
            transaction_request: 'Færslubeiðni',
            transaction_response: 'Færslusvar',
            error_message: 'Villuskilaboð',
            error_code: 'Villukóði',
            request_type: 'Gerð beiðni',
            response_code: 'Svarkóði',
            response_code_description: 'Lýsing svarkóða',
            null_data: 'Engin gögn fundust',
            transaction_date: 'Dagsetning færslu',
            failureReason: 'Ástæða höfnunar',
        },
        button: {
            search: 'Leita',
            cancel: 'Hætta við',
            save: 'Vista',
            add: 'Bæta við',
            edit: 'Breyta stöðu',
            reset: 'Endurstilla',
            yes: 'Já',
            no: 'Nei',
            action: 'Aðgerð',
            back: 'Til baka',
        },
    },
    chargeTariff: {
        title: 'Gjaldskrár: ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Gjaldskrár',
        tariff: 'Gjaldskrá',
        columns: {
            location: 'Staðsetning',
            chargeStation: 'Nafn hleðslustöðvar',
            connector: 'Tengi',
            standard: 'Staðall',
        },
        label: {
            name: 'Nafn',
            vat_name: 'VSK-nafn',
            vat_rate: 'Gjald (%)',
            vat_description: 'Lýsing',
            cpo_id: 'cpo-auðkenni',
            action: 'Aðgerð',
            url: 'vefslóð',
            currency: 'Gjaldmiðill',
            createdDate: 'Stofndags.',
            status: 'Staða',
            enabled: 'Virkt',
            deleted: 'Eytt',
            detail: 'Upplýsingar',
            promotions: 'Kynningar',
            lastUpdated: 'Síðast uppfært',
            promotionCode: 'Kynningarkóði',
            description: 'Lýsing',
            expiryDate: 'Fyrningardagsetning',
            priceComponents: 'Verðhlutar',
            priceComponent: 'Verðhluti',
            type: 'TEGUND',
            price: 'VERÐ',
            pricePerHour: 'Verð (á klukkutíma)',
            restriction: 'Takmörkun',
            startDate: 'upphafsdagsetning',
            startTime: 'Upphafstími',
            endDate: 'Lokadagsetning',
            endTime: 'Lokatími',
            minkWh: 'Lágm. kWh',
            maxkWh: 'Hám. kWh',
            minPower: 'Lágm. afköst',
            maxPower: 'Hám. afköst',
            minDuration: 'Lágm. lengd',
            maxDuration: 'Hám. lengd',
            weekDays: 'Vikudagar',
            selectVat: 'Veldu VSK',
            attachVat: 'Setja VSK í viðhengi',
            vatdetail: 'VSK-upplýsingar',
            editVAT: 'Breyta VSK-gerð',
            vatType: 'VSK-gerð',
            tariffID: 'Auðkenni gjaldskrár',
            element: 'HLUTI',
            prices: 'Verð',
            restrictions: 'Takmarkanir',
            stepSize: 'SKREFASTÆRÐ',
            vat: 'VSK',
            date: 'DAGSETNING',
            time: 'KLUKKUSTUND',
            kwh: 'KWH',
            power: 'AFKÖST (KW)',
            duration: 'TÍMABIL (SEC)',
            current: 'STRAUMUR (AMP)',
            maxCurrent: 'Hámarksstraumur',
            minCurrent: 'Lágmarksstraumur',
            restrictionTitle: 'TAKMARKANIR',
            details: 'Upplýsingar',
            weekDaysTitle: 'VIKUDAGAR',
            maxKwhTitle: 'Hámark KWH',
            minKwhTitle: 'Lágmark KWH',
            accessGroups: 'Aðgangshópar',
            locations: 'Staðsetningar',
            CPOs: 'CPOs',
            connectors: 'Tengi',
        },
        placeholder: {
            name: 'Nafn',
            selectStatus: 'Velja stöðu',
            selectVat: 'Veldu VSK',
            selectType: 'Veldu VSK-gerð',
            tariffID: 'Auðkenni gjaldskrár',
            vatType: 'VSK-gerð',
            currency: 'Gjaldmiðill',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            action: 'Aðgerð',
            edit: 'Breyta',
            detail: 'Upplýsingar',
            add: 'Bæta við',
            back: 'Til baka',
            save: 'Vista',
            cancel: 'Hætta við',
            editvat: 'Setja VSK í viðhengi',
            editVAT: 'Breyta VSK-gerð',
            groupRestrictions: 'Takmarkanir Hóps Taxta',
            ungroupRestrictions: 'Takmarkanir Óhópaðs Taxta',
        },
        noRestrictionAvailable: 'Engar Takmarkanir Tiltækar',
    },
    partnerPromotion: {
        title: 'Kynningar samstarfsaðila : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Kynningar samstarfsaðila',
        placeholder: {
            nameorcompany: 'Nafn eða fyrirtæki',
            status: 'Velja stöðu',
            date_from: 'Upphafsdagsetning',
            date_to: 'Lokadagsetning',
        },
        label: {
            name: 'Nafn',
            company: 'Fyrirtæki',
            description: 'Lýsing',
            date_from: 'Upphafsdagsetning',
            date_to: 'Lokadagsetning',
            expiry_date: 'Fyrningardagsetning',
            created_date: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            delete: 'Eyða',
        },
        button: {
            search: 'Leita',
            cancel: 'Hætta við',
            add: 'Bæta við',
            save: 'Vista',
            edit: 'Breyta',
            reset: 'Endurstilla',
            delete: 'Eyða',
            yes: 'Já',
            no: 'Nei',
            enabled: 'Virkja',
            disabled: 'Afvirkja',
            action: 'Aðgerð',
            back: 'Til baka',
            enable: 'Virkja',
            disable: 'Afvirkja',
            chargeStation: 'Hleðslustöðvar',
            preview: 'Forskoða',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
        },
        insert: {
            header: 'Sjá um kynningar samstarfsaðila',
            placeholder: {
                name: 'Nafn',
                company: 'Upplýsingar um fyrirtæki',
                description: 'Lýsing',
                start_date: 'Upphafsdagsetning',
                expiry_date: 'Fyrningardagsetning',
                offer_duration: '60 mínúta',
                stored_for_future_use_days: '2 dagar',
                qr_code_details: 'Upplýsingar um QR-kóða',
                certificate: 'Vottorð',
                image: 'Kynningarmynd',
                image1: 'Viðbótarmynd 1',
                image2: 'Viðbótarmynd 2',
                image3: 'Viðbótarmynd 3',
                image4: 'Viðbótarmynd 4',
                image5: 'Viðbótarmynd 5',
                banner_image: 'Vörumerki kynningar',
                locationPageImage: 'Mynd staðsetningarsíðu',
                displayOnChargeLocation: 'Birta á skjá hleðslustöðu',
                promotion_button_text: 'Texti kynningarhnapps',
            },
            label: {
                name: 'Nafn',
                company: 'Fyrirtæki',
                description: 'Lýsing',
                start_date: 'Upphafsdagsetning',
                expiry_date: 'Fyrningardagsetning',
                offer_duration: 'Lengd kynningar (Mínútur)',
                stored_for_future_use_days: 'Vista til að nota síðar (dagar)',
                always_display_on_partner_promotion: 'Birta ávallt kynningar samstarfsaðila',
                qr_code_details: 'QR-kóði',
                certificate: 'Vottorð',
                image: 'Kynningarmynd',
                banner_image: 'Vörumerki kynningar (1030 X 430)',
                layout: 'Skjásnið',
                note1: 'Vinsamlega athugið að taka þarf fram <strong>##image##</strong> og <strong>##qrcode##</strong> yfir HTML skjásniði til að skipta út viðeigandi upplýsingum. Hægt er að bæta viðbótarupplýsingum við snið með því að nota ##image0X##, þar sem X getur verið 1 til 5.',
                qr_code_note:
                    'Vinsamlega athugið að taka þarf fram <strong>##ChargeTransID##</strong>, <strong>##StartChargeTS##</strong>, <strong>##ChargeStationID##</strong> og <strong>##ChargeStationAddress##</strong> yfir QR-kóða til að skipta út viðeigandi upplýsingum.',
                locationPageImage: 'Mynd staðsetningarsíðu',
                displayOnChargeLocation: 'Birta á skjá hleðslustöðu',
                partner_promotion_display_type: 'Gerð kynningarskjás',
                promotion_button_text: 'Texti kynningarhnapps',
                open_external_url: 'Opna ytri hlekk',
                external_url: 'Ytri hlekkur',
                image1: 'Viðbótarmynd 1',
                image2: 'Viðbótarmynd 2',
                image3: 'Viðbótarmynd 3',
                image4: 'Viðbótarmynd 4',
                image5: 'Viðbótarmynd 5',
            },
            errors: {
                common: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
                name: {
                    valid: 'Sláðu inn gilt nafn kynningar',
                    max: 'Kynningarmynd er of stór',
                },
                description: {
                    max: 'Lýsing kynningar er of stór',
                },
                offer_duration: {
                    moreThan: 'Lengd kynningar verður að vera meira en 0',
                    max: 'Lengd kynningar má ekki vera meira en 60 mínútur',
                },
                stored_for_future_use_days: {
                    moreThan: 'Dagur til að vista fyrir síðari notkun verður að vera meira en 0',
                    max: 'Dagur til að vista fyrir síðari notkun má ekki vera meira en 99 dagar',
                },
                banner_image: {
                    dimensions: 'Vörumerki kynningar verður að vera 1030 X 430',
                },
                image: {
                    fileType: 'Hægt er að hlaða upp .jpg-,.png-, .svg- og .jpeg-skrám',
                    location_page_image: 'Mynd staðsetningarsíðu vantar',
                },
                certificate: {
                    fileType: 'Hægt er að hlaða upp .crt- og .cer-skrám',
                },
                promotion_button_text: {
                    valid: 'Sláðu inn gildan texta fyrir kynningarhnapp',
                },
                external_url: {
                    url: 'Ytri hlekkur verður að vera gildur hlekkur',
                },
            },
        },
        assign: {
            header: 'Hleðslustöðvar',
            headerModal: 'Hleðslustöð',
            placeholder: {
                name: 'Sláðu inn nafn',
                locationName: 'Sláðu inn heiti staðsetningar',
                address: 'Heimilisfang',
                tags: 'Velja merki',
            },
            label: {
                add: 'Bæta við',
                name: 'Nafn',
                type: 'Gerð',
                address: 'Heimilisfang',
                city: 'Borg',
                postcode: 'Póstnúmer',
                last_updated: 'Dagsetning breytingar',
                action: 'Aðgerð',
                delete: 'Eyða',
            },
            button: {
                delete: 'Eyða',
            },
            message: {
                deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            },
        },
    },
    CPOInterface: {
        title: 'Aðgangar : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Aðgangar',
        placeholder: {
            name: 'Nafn',
            status: 'Velja stöðu',
        },
        label: {
            name: 'Nafn',
            party_id: 'Auðkenni aðila',
            country_code: 'Landkóði',
            version_url: 'Útgáfuhlekkur',
            created_date: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            locationGroup: 'Hópstaðsetning',
            yes: 'Já',
            no: 'Nei',
            rfidDriverTokens: 'Deila aðeins tákni RFID-rekils',
            vat_type: 'VSK-gerð',
            version_2_1_1: '2.1.1',
            version_2_2: '2.2',
            version_2_2_1: '2.2.1',
            external_cpo: '##COMPANY_BRAND_NAME## alþjóðlegt CPO',
            cpo_type: 'CPO Tegund',
            override_tariff: 'Hnekkja gjaldskrá',
            provides_session_total_cost_updates: 'Veitir Uppfærslur Á Heildarkostnaði Lotu',
        },
        button: {
            search: 'Leita',
            cancel: 'Hætta við',
            add: 'Bæta við',
            save: 'Vista',
            edit: 'Breyta',
            reset: 'Endurstilla',
            yes: 'Já',
            no: 'Nei',
            enabled: 'Virkja',
            disabled: 'Afvirkja',
            action: 'Aðgerð',
            back: 'Til baka',
            enable: 'Virkja',
            disable: 'Afvirkja',
            getCredentials: 'Fá skilríki',
            performHandshake: 'Hefja handaband',
            reHandshake: 'Endurtaka handaband',
            generateHandshakeToken: 'Mynda handabandstoken',
            reGenerateHandshakeToken: 'Mynda handabandstoken aftur',
            changeMutualOCPIVersion: 'Breyta sameiginlegri OCPI-útgáfu',
            handshakeDetails: 'Upplýsingar um handaband',
        },
        message: {
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage:
                'Með því að slökkva á þessu CPO verður öllum OCPI samskiptum hætt, tengdum hleðslustöðum verður falinn í öppum, tengdar hleðslustöðvar verða merktar sem "Fjarlægðar" og staðsetningar fjarlægðar úr aðgangshópum. Ertu viss um að þú viljir halda áfram?',
        },
        insert: {
            header: 'Stýra stjórnanda hleðslustaðar',
            placeholder: {
                name: 'Nafn',
                party_id: 'Auðkenni aðila',
                country_code: 'Landkóði',
                ocpi: 'EMSP',
                version_url: 'Útgáfuhlekkur CPO',
                token_a: 'Tákn A',
                token_b: 'Tákn B',
                token_c: 'Tákn C',
                colour_code: 'Litakóði',
                back_office_url: 'Bakvinnsluhlekkur',
                vat_type: 'VSK-gerð',
                region: 'Veldu svæði',
                vat: 'Veldu VSK',
                cpo_type: 'CPO Tegund',
            },
            label: {
                name: 'Nafn',
                party_id: 'Auðkenni aðila',
                country_code: 'Landkóði',
                ocpi: 'EMSP',
                version_url: 'Útgáfuhlekkur',
                token_a: 'Tákn A',
                token_b: 'Tákn B',
                token_c: 'Tákn C',
                locationGroup: 'Hópstaðsetning',
                rfidDriverTokens: 'Deila aðeins tákni RFID-rekils',
                colour_code: 'Litakóði',
                back_office_url: 'Bakvinnsluhlekkur',
                vat_type: 'VSK-gerð',
                disableLocationPatchPutRemovals: 'Gera óvirkar PATCH/PUT-fjarlægingar',
                enableLocationPatchPutRemovals: 'Virkjaðu fjarlægingu staðsetningarplástra/PUT',
                enableAutoMaxPowerCalculation: 'Virkja útreikninga hámarksafkasta',
                mutual_ocpi_version: 'Sameiginleg OCPI-útgáfa',
                externalCPO: 'Tengd svæði',
                is_external: '##COMPANY_BRAND_NAME## alþjóðlegt CPO',
                defaultVat: 'Staðlaður VSK (Hnekkja)',
                gmbAccountID: 'GMB-aðgangsauðkenni',
                cpo_type: 'CPO Tegund',
            },
            errors: {
                common: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
                name: {
                    valid: 'Sláðu inn gilt CPO-nafn',
                },
                party_id: {
                    valid: 'Sláðu inn gilt auðkenni aðila',
                },
                country_code: {
                    valid: 'Sláðu inn gildan landkóða',
                },
                version_url: {
                    url: 'Útgáfuhlekkur verður að vera gildur hlekkur',
                },
                colour_code: {
                    valid: 'Sláðu inn gildan litakóða',
                },
                back_office_url: {
                    url: 'Bakvinnsluhlekkur verður að vera gildur hlekkur',
                },
            },
        },
        versionEndpoints: {
            header: 'Lokapunktar útgáfu',
            label: {
                version: 'Útgáfa',
                identifier: 'Auðkenni',
                role: 'Hlutverk',
                url: 'vefslóð',
                last_executed: 'Síðasta samstilling framkvæmd',
            },
        },
        modal: {
            message:
                'Þú ert að merkja þetta CPO sem ##COMPANY_BRAND_NAME## alþjóðlegt CPO. Bæta þarf þessum CPO-staðsetningum handvirkt við í opnum hópi',
            okButton: 'Í lagi',
        },
        confirmationModal: {
            header: 'Uppfærðu Mutual OCPI útgáfu',
            message: 'Ertu viss um að þú viljir uppfæra Mutual OCPI útgáfu?',
        },
        performHandshakeModal: {
            handshakeHeader: 'Hefja handaband',
            reHandshakeHeader: 'Endurtaka handaband',
            label: {
                mutual_ocpi_version: 'Sameiginleg OCPI útgáfa',
                version_url: 'Útgáfuslóð',
                handshake_token: 'Handabandstoken',
            },
            placeholder: {
                mutual_ocpi_version: 'Sameiginleg OCPI útgáfa',
                version_url: 'Útgáfuslóð',
                handshake_token: 'Handabandstoken',
            },
            button: {
                cancel: 'Hætta við',
                generateHandshakeToken: 'Mynda handabandstoken',
                confirm: 'Staðfesta',
                connect: 'Tengdu',
                reconnect: 'Tengdu aftur',
            },
            confirmationModal: {
                header: 'Hefja handaband',
                rehandshakeMessage:
                    'CPO skilríki breytast eftir endurtekningu á handabandi. Ertu viss um að þú viljir halda áfram með endurtekningu á handabandi?',
                tokenGeneratedMessage:
                    'Handabandstoken fyrir CPO hefur þegar verið myndað. Ef tokenið er gefið CPO og CPO reynir að hefja handaband með EMSP gæti það mistakast. Ertu viss um að þú viljir halda áfram með endurtekningu á handabandi?',
            },
            cpoAuthTokenMessage: 'Sjálfgefið gildi sem sýnt er hér er CPO Auth Token',
        },
        generateHandshakeTokenModal: {
            header: 'Mynda handabandstoken',
            reGenerateTokenHeader: 'Mynda handabandstoken aftur',
            label: {
                handshakeToken: 'Handabandstoken',
                emsp_auth_token: 'EMSP skilríki',
                emspVersionURL: 'Vefslóð EMSP útgáfu',
            },
            Placeholder: {
                handshakeToken: 'Handabandstoken',
                emsp_auth_token: 'EMSP skilríki',
            },
            button: {
                save: 'Vista',
                copyToClipboard: 'Afrita á klippibúð',
                generateToken: 'Mynda',
                reGenerateToken: 'Mynda aftur',
                confirm: 'Staðfesta',
                cancel: 'Hætta við',
            },
            copyToClipboard: {
                success: 'Token afritað á klippibúð',
                failed: 'Mistókst að afrita token',
            },
            confirmationModal: {
                confirmationMessage:
                    'Ef gamla handabandstokeninu er gefið CPO gæti það mistakast ef CPO reynir að nota það fyrir handabandið. Ertu viss um að þú viljir vista nýja handabandstoken?',
                header: 'Vista token',
            },
            emspAuthTokenMessage: 'Sjálfgefið gildi sem sýnt er hér er EMSP Auth Token',
        },
        changeMutualOCPIVersionModal: {
            header: 'Breyta sameiginlegri OCPI útgáfu',
            label: {
                mutualOCPIVersion: 'Sameiginleg OCPI útgáfa',
            },
            button: {
                save: 'Vista',
                cancel: 'Hætta við',
                confirm: 'Staðfesta',
            },
            confirmationModal: {
                confirmationMessage: 'Ertu viss um að þú viljir uppfæra sameiginlega OCPI útgáfu?',
            },
        },
        handshakeDetailsModal: {
            header: 'Upplýsingar um handaband',
            label: {
                version_url: 'Útgáfuslóð',
                handshakeToken: 'Handabandstoken',
                emspAuthToken: 'EMSP skilríki',
                cpoAuthToken: 'CPO skilríki',
            },
        },
    },
    CPOInternalTransfers: {
        title: 'Innri færslur : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Innri færslur',
        transferDetailTitle: 'Upplýsingar um færslur : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        transferDetailHeader: 'Upplýsingar um færslur',
        label: {
            transfer_id: 'Auðkenni færslu',
            gross_value: 'Heildarverðgildi',
            created_date: 'Stofndags.',
            action: 'Aðgerð',
            transferNumber: 'Færslunúmer',
            transferDate: 'Færsludagsetning',
            transaction: 'Auðkenni færslu',
            transactionStartDate: 'Upphafsdagur færslu',
            transactionEndDate: 'Lokadagur færslu',
            publicCardId: 'Almennt kortaauðkenni',
            driverAccountId: 'Aðgangsauðkenni bílstjóra',
            driverName: 'Bílstjóra-/bifreiðanr.',
            stationId: 'Auðkenni stöðvar',
            stationName: 'Heiti stöðvar',
            stationAddress: 'Heimilisfang stöðvar',
            kwh: 'kWh',
            price_per_kwh: 'Verð/kWh',
            disable: 'ÓVIRKT',
        },
        placeholder: {
            start_date: 'Upphafsdagsetning',
            end_date: 'Lokadagsetning',
            status: 'Staða',
            cpo: 'Veldu CPO',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            action: 'Aðgerð',
        },
        errors: {
            cpo: {
                required: 'Vinsamlega veldu CPO',
            },
        },
    },
    PSPSetting: {
        title: 'Þjónustuaðilar greiðslna : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Þjónustuaðilar greiðslna',
        placeholder: {
            name: 'Nafn',
            status: 'Velja stöðu',
            type: 'Velja gerð',
        },
        label: {
            name: 'Nafn',
            code: 'Kóði',
            type: 'Gerð',
            description: 'Lýsing',
            store_name: 'Verslun',
            department_name: 'Deild',
            created_date: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            details: 'Upplýsingar',
            key: 'Lykill',
            value: 'Verðgildi',
        },
        button: {
            search: 'Leita',
            cancel: 'Hætta við',
            add: 'Bæta við',
            save: 'Vista',
            edit: 'Breyta',
            reset: 'Endurstilla',
            yes: 'Já',
            no: 'Nei',
            enabled: 'Virkja',
            disabled: 'Afvirkja',
            action: 'Aðgerð',
            back: 'Til baka',
            enable: 'Virkja',
            disable: 'Afvirkja',
            getCredentials: 'Fá skilríki',
            delete: 'Eyða',
        },
        message: {
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
        },
        insert: {
            header: 'Sjá um þjónustuaðila greiðslu',
            placeholder: {
                name: 'Nafn',
                type: 'Gerð',
                description: 'Lýsing',
                store_name: 'Nafn verslunar',
                store_id: 'Auðkenni verslunar',
                merchant_name: 'Nafn söluaðila',
                merchant_id: 'Auðkenni söluaðila',
                department_name: 'Nafn deildar',
                department_id: 'Auðkenni deildar',
                signature_key: 'Lykill undirskriftar',
                secret_key: 'Leynilykill',
                user_name: 'Notandanafn',
                password: 'Lykilorð',
                data: 'Gögn',
                category: 'Flokkur',
                url: 'vefslóð',
                acquirerId: 'Auðkenni yfirtaka',
                firstName: 'Skírnarnafn',
                lastName: 'Föðurnafn',
                houseName: 'Nafn húss',
                postcode: 'Póstnúmer',
                donationProviderType: 'Gerð áheita aðgangsveitanda',
                isGiftAid: 'Er gjafaaðstoð',
                donationStoreId: 'Auðkenni áheitaverslunar',
                donationMerchantNumber: 'Númer áheitasöluaðila',
                clientID: 'Auðkenni viðskiptavinar',
                clientSecret: 'Leyndarmál viðskiptavinar',
                terminalID: 'Auðkenni stöðvar',
                enableCardRefunds: 'Virkja kortaendurgreiðslur',
                enableCardVerification: 'Virkja auðkenningu korts',
                enableCharity: 'Virkja áheit',
                mobileMerchantId: 'Auðkenni farsímasöluaðila',
                mobileMerchantPassword: 'Aðgangsorð farsímakaupmanns',
                enableIncrementalAuthorizations: 'Virkja Stigvaxandi Heimildir',
            },
            label: {
                name: 'Nafn',
                type: 'Gerð',
                firstName: 'Skírnarnafn',
                lastName: 'Föðurnafn',
                houseName: 'Nafn húss',
                postcode: 'Póstnúmer',
                donationProviderType: 'Gerð áheita aðgangsveitanda',
                isGiftAid: 'Er gjafaaðstoð',
                donationStoreId: 'Auðkenni áheitaverslunar',
                donationMerchantNumber: 'Númer áheitasöluaðila',
                code: 'Kóði',
                description: 'Lýsing',
                store_name: 'Nafn verslunar',
                store_id: 'Auðkenni verslunar',
                merchant_name: 'Nafn söluaðila',
                merchant_id: 'Auðkenni söluaðila',
                department_name: 'Nafn deildar',
                department_id: 'Auðkenni deildar',
                signature_key: 'Lykill undirskriftar',
                secret_key: 'Leynilykill',
                user_name: 'Notandanafn',
                password: 'Lykilorð',
                data: 'Gögn',
                action_urls: 'Aðgerðahlekkir',
                category: 'Flokkur',
                url: 'vefslóð',
                acquirerId: 'Auðkenni yfirtaka',
                clientID: 'Auðkenni viðskiptavinar',
                clientSecret: 'Leyndarmál viðskiptavinar',
                terminalID: 'Auðkenni stöðvar',
                enableCardRefunds: 'Virkja kortaendurgreiðslur',
                enableCardVerification: 'Virkja auðkenningu korts',
                enableCharity: 'Virkja áheit',
                mobileMerchantId: 'Auðkenni farandssöluaðila',
                mobileMerchantPassword: 'Lykilorð farandssöluaðila',
                enableIncrementalAuthorizations: 'Virkja Stigvaxandi Heimildir',
                excludedCardsForIncrementalAuthorizations: 'Útilokuð kort fyrir stigvaxandi heimildir',
            },
            errors: {
                common: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
                name: {
                    valid: 'Sláðu inn gilt nafn',
                },
                code: {
                    valid: 'Sláðu inn gildan kóða',
                },
                url: {
                    valid: 'Hlekkur verður að vera gildur hlekkur',
                },
                DatatransSupportCards: {
                    valid: 'Vinsamlegast sláðu inn gilt gildi fyrir DatatransSupportCards',
                },
            },
        },
    },
    RFIDCards: {
        title: 'RFID-kort : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'RFID-kort',
        placeholder: {
            name: 'Nafn bílstjóra/netfang/stofnun',
            manufacturer: 'Framleiðandi',
            part_id: 'Auðkenni hluta',
            public_card_id: 'Auðkenni almenns korts',
            status: 'Velja stöðu',
            mifare_uid: 'Mifare UID',
        },
        label: {
            name: 'Úthlutað til',
            email_vehicle: 'Tengdur aðgangur',
            manufacturer: 'Framleiðandi',
            part_id: 'Auðkenni hluta',
            public_card_id: 'Auðkenni almenns korts',
            private_card_id: 'Auðkenni einkakorts',
            created_date: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            delete: 'Eyða',
            deAllocate: 'Fjarlægja tengingu',
            view: 'Skoða upplýsingar',
            allocateCardToOrganisation: 'Úthluta fjöldakortum til stofnunar',
            mifare_uid: 'MIFARE UID',
            reinstate: 'Endurúthluta korti',
            card_type: 'Kortategund',
            removeBulkAssociation: 'Fjarlægja fjölda tenginga RFID-korta',
        },
        button: {
            search: 'Leita',
            cancel: 'Hætta við',
            add: 'Bæta við',
            addBulk: 'Bæta við kortum í magni til framleiðslu',
            assing: 'Úthluta RFID-kortum',
            allocateRFIDCard: 'Ráðstafa RFID-kortum',
            import: 'Flytja inn framleiðsluskrá',
            export: 'Flytja út framleiðsluskrá',
            save: 'Vista',
            edit: 'Breyta',
            reset: 'Endurstilla',
            yes: 'Já',
            no: 'Nei',
            enabled: 'Virkja',
            disabled: 'Afvirkja',
            action: 'Aðgerð',
            back: 'Til baka',
            enable: 'Virkja',
            disable: 'Afvirkja',
            getCredentials: 'Fá skilríki',
            delete: 'Eyða',
            deAllocate: 'Fjarlægja tengingu',
            view: 'Skoða upplýsingar',
            reinstate: 'Endurúthluta korti',
            forceCPOUpdate: 'Þvinga CPO-uppfærslu',
        },
        errors: {
            export: {
                notSeletedCards: 'Vinsamlega veldu útflutningskort í bið',
            },
        },
        message: {
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            deAllocateConfirmMesage: 'Ertu viss um að þú viljir eyða tengingu RFID-korta að aðgangi?',
            reinstateConfirmMessage: 'Ertu viss um að þú viljir endurráðstafa RFID-korti?',
            forceCPOUpdateConfirmMessage: 'Ertu viss um að þú viljir þvinga uppfærslutákn í CPO kerfi?',
        },
        insert: {
            header: 'Sjá um RFID-kort',
            placeholder: {
                manufacturer: 'Nafn framleiðanda',
                part_id: 'Auðkenni hluta',
                public_card_id: 'Auðkenni almenns korts',
                private_card_id: 'Auðkenni einkakorts',
                mifare_uid: 'Mifare UID',
                card_type: 'Kortategund',
            },
            label: {
                manufacturer: 'Framleiðandi',
                part_id: 'Auðkenni hluta',
                public_card_id: 'Auðkenni almenns korts',
                private_card_id: 'Auðkenni einkakorts',
                mifare_uid: 'Mifare UID',
                card_type: 'Kortategund',
            },
            errors: {
                common: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
                name: {
                    valid: 'Sláðu inn gilt nafn',
                },
                code: {
                    valid: 'Sláðu inn gildan kóða',
                },
                url: {
                    valid: 'Hlekkur verður að vera gildur hlekkur',
                },
            },
        },
        bulkCards: {
            header: 'Bæta við kortum í magni',
            placeholder: {
                manufacturer: 'Nafn framleiðanda',
                part_id: 'Auðkenni hluta',
                no_of_cards: '100 kort',
                cardType: 'Veldu kortategund',
            },
            label: {
                manufacturer: 'Nafn framleiðanda',
                part_id: 'Auðkenni hluta',
                no_of_cards: 'Fjöldi korta',
                cardType: 'Kortategund',
            },
            button: {
                yes: 'Búa til kort',
                no: 'Hætta við',
            },
            errors: {
                no_of_cards: {
                    min: 'Fjöldi korta má ekki vera minni en 1',
                },
            },
        },
        assignCards: {
            header: 'Úthluta RFID-kortum',
            header2: 'Þú hefur valið X kort.',
            selectedCard: 'Þú hefur valið 1 kort.',
            placeholder: {
                manufacturer: 'Nafn framleiðanda',
                part_id: 'Auðkenni hluta',
                no_of_cards: '100 kort',
            },
            label: {
                driver: 'Ökumaður',
                organisation: 'Stofnun',
                no_of_cards: 'Fjöldi korta',
            },
            button: {
                yes: 'Úthluta',
                no: 'Hætta við',
            },
            form: {
                type: {
                    driver: 'Ökumaður',
                    organisation: 'Stofnun',
                },
                driver: 'Ökumaður',
                organisation: 'Stofnun',
                placeholder: {
                    driver: 'Velja bílstjóra',
                    organisation: 'Velja stofnun',
                },
            },
            errors: {
                notSeletedCards: 'Vinsamlega veldu tiltæk kort',
            },
        },
        disableCards: {
            header: 'Afvirkja',
            header2: 'Ertu viss um að þú viljir afvirkja?',
            placeholder: {
                comment: 'Slá inn athugasemd',
            },
            label: {
                comment: 'Athugasemd',
            },
            button: {
                yes: 'Já',
                no: 'Nei',
            },
        },
        allocateCards: {
            header: 'Ráðstafa RFID-kortum',
            placeholder: {
                file: 'Veldu CSV-skrá',
                selectOrganisation: 'Velja stofnun',
            },
            label: {
                file: 'CSV-skrá',
                organisation: 'Stofnun',
                mifareUID: 'MifareÂ UID',
                publicCardID: 'PublicÂ CardÂ ID',
                clickHere: 'Smelltu hér',
                downloadTemplate: 'til að hlaða niður sniðmáti',
            },
            button: {
                allocate: 'Ráðstafa',
                cancel: 'Hætta við',
            },
            errors: {
                file: {
                    fileType: 'Hægt er að hlaða upp skrár með „.csv“-skráarheiti',
                },
            },
        },
        removeAssociation: {
            header: 'Fjarlægja fjölda tenginga RFID-korta',
            placeholder: {
                file: 'Veldu CSV-skrá',
            },
            label: {
                file: 'CSV-skrá',
                clickHere: 'Smelltu hér',
                downloadTemplate: 'til að hlaða niður sniðmáti',
            },
            button: {
                save: 'Vista',
                cancel: 'Hætta við',
            },
            errors: {
                file: {
                    fileType: 'Hægt er að hlaða upp skrár með „.csv“-skráarheiti',
                },
                maxRFIDRecordsReached:
                    'CSV-skráin, sem þú hlóðst upp, fór yfir hámarksfjölda 10.000 auðkennaskráninga opinberra korta RFID-korta. Vinsamlega fækkið skráningum opinberra korta RFID-korta í CSV-skránni.',
            },
        },
        importCards: {
            header: 'Flytja inn RFID-kort',
            placeholder: {
                file: 'Veldu CSV-skrá',
            },
            label: {
                file: 'CSV-skrá',
            },
            button: {
                yes: 'Flytja inn',
                no: 'Hætta við',
            },
            errors: {
                file: {
                    fileType: 'Hægt er að hlaða upp skrár með „.csv“-skráarheiti',
                },
            },
        },
        importCardsDetails: {
            header: 'Upplýsingar um innflutning RFID korta',
            label: {
                unSuccessfullImport: 'Eftirfarandi kort er ekki hægt að flytja inn',
                successfullImport: 'Eftirfarandi kort hafa verið flutt inn með góðum árangri',
                failerReason: 'Ástæða bilunar',
                publicCardId: 'Auðkenni opinbers korts',
            },
            message: {
                defualtErrorMessage: 'Vandamál kom upp við innflutning eftirfarandi korta.',
            },
        },
        rfidDetails: {
            label: {
                event_date: 'Dagsetning viðburðar',
                chargeLocation: 'Hleðslustaður',
                charge_station_name: 'Heiti stöðvar',
                response_status: 'Staða svars',
            },
        },
    },
    referralPromotion: {
        title: 'Tilvísunarkynning: ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Tilvísunarkynningar',
        manageReferralPromotion: 'Sjá um tilvísunarkynningu',
        label: {
            name: 'Nafn',
            code: 'Kóði',
            minCharge: 'Lágm. Hleðsla',
            maxLimit: 'Hám. Mörk',
            maxRefreeLimit: 'Hám. Mörk tilvísanda',
            createdDate: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
            disabled: 'Óvirkt',
            enabled: 'Virkt',
            delete: 'Eyða',
            enable: 'Virkja',
            disable: 'Afvirkja',
            promotionCode: 'Kynningarkóði',
            description: 'Lýsing',
            maxReferralLimit: 'Hámarks tilvísunarmörk',
            minChargeValue: 'Lágmarks tilvísunarmörk',
            refereeBonus: 'Tilvísandabónus',
            referrerBonus: 'Bónus þess sem vísaði til',
        },
        button: {
            search: 'Leita',
            back: 'Til baka',
            add: 'Bæta við',
            reset: 'Endurstilla',
            edit: 'Breyta',
            delete: 'Eyða',
            enable: 'Virkja',
            disable: 'Afvirkja',
            save: 'Vista',
            cancel: 'Hætta við',
            action: 'Aðgerð',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
        },
        placeholder: {
            name: 'Nafn',
            code: 'Kóði',
            selectPromotion: 'Velja kynningu',
            selectStatus: 'Velja stöðu',
            promotionCode: 'Kynningarkóði',
            description: 'Lýsing',
            maxReferralLimit: 'Hámarks tilvísunarmörk',
            minChargeValue: 'Lágmarks tilvísunarmörk',
            refereeBonus: 'Tilvísandabónus',
            referrerBonus: 'Bónus þess sem vísaði til',
        },
        errors: {
            name: {
                valid: 'Sláðu inn gilt nafn kynningar',
            },
            promotionCode: {
                valid: 'Sláðu inn gildan kynningarkóða',
            },
            maxReferralLimit: {
                moreThan: 'Hámarks tilvísunarbónus verður að vera meiri en núll',
            },
            referrerBonus: {
                max: 'Tilvísunarbónusgildi má ekki vera hærra en ##MAX_REFERRAL_BONUS##',
            },
            refereeBonus: {
                max: 'Tilvísunarbónusgildi má ekki vera hærra en ##MAX_REFERRAL_BONUS##',
            },
        },
    },
    termsConditions: {
        title: 'Skilmálar: ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Skilmálar',
        manageTermsConditions: 'Sjá um notkunarskilmála',
        label: {
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            name: 'Nafn',
            description: 'Lýsing',
            apply_to: 'Bæta við',
            mandatory_for_user: 'Áskilið fyrir notanda',
            status: 'Staða',
            delete: 'Eyða',
            content: 'Stefna',
            yes: 'Já',
            no: 'Nei',
            draft: 'Drög',
            published: 'Birt',
        },
        placeholder: {
            name: 'Nafn',
            description: 'Lýsing',
            select: {
                apply_to: 'Bæta við',
                status: 'Velja stöðu',
            },
        },
        columns: {
            name: 'Nafn',
            description: 'Lýsing',
            applyto: 'Bæta við',
            mandatory_for_user: 'Áskilið',
            status: 'Staða',
            action: 'Aðgerð',
            modified_date: 'Breytt þann',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            action: 'Aðgerð',
            edit: 'Breyta',
            add: 'Bæta við',
            back: 'Til baka',
            save: 'Vista',
            cancel: 'Hætta við',
            delete: 'Eyða',
            yes: 'Já',
            no: 'Nei',
        },
        errors: {
            name: {
                valid: 'Sláðu inn gilt nafn',
            },
            invalidFormat: 'Vinsamlega hlaðið upp gildu myndasniði',
            common: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
        },
    },
    rewardPromotion: {
        title: 'Umbunarkynningar: ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'IV umbunarkynningar',
        manageRewardPromotion: 'Sjá um IV umbunarkynningu',
        label: {
            name: 'Nafn',
            code: 'Kóði',
            valuesPerkwh: 'Gildi á kWh',
            monetoryValue: 'Peningalegt gildi',
            redemptionBlock: 'Innlausnareining',
            createdDate: 'Stofndags.',
            status: 'Staða',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            action: 'Aðgerð',
            delete: 'Eyða',
            enable: 'Virkja',
            disable: 'Afvirkja',
            promotionCode: 'Kynningarkóði',
            description: 'Lýsing',
            expired: 'Útrunnið',
            locationApplicable: 'Hleðslustaður á við',
            voltsPerkwh: 'Volt á kWh',
            confirmation: 'Staðfesting',
        },
        button: {
            search: 'Leita',
            cancel: 'Hætta við',
            save: 'Vista',
            add: 'Bæta við',
            edit: 'Breyta',
            reset: 'Endurstilla',
            delete: 'Eyða',
            enable: 'Virkja',
            disable: 'Afvirkja',
            action: 'Aðgerð',
            back: 'Til baka',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
            uncheckConfirmMesage:
                'Allar hleðslustaðsetningar sem tengjast þessari kynningu verða fjarlægðar með því að fjarlægja hakið af þessum valreit. Ertu viss um að þú viljir halda áfram?',
        },
        placeholder: {
            name: 'Nafn',
            code: 'Kóði',
            selectPromotion: 'Veldu kynningu',
            selectStatus: 'Velja stöðu',
            locationApplicable: 'Hleðslustaður á við',
            voltsPerkwh: 'Volt á kWh',
        },
        errors: {
            name: {
                valid: 'Sláðu inn gilt nafn kynningar',
            },
            promotionCode: {
                valid: 'Sláðu inn gildan kynningarkóða',
            },
            monetoryValue: {
                moreThan: 'Peningalegt gildi verður að vera meira en núll',
                lessThan: 'Peningalegt gildi verður að vera minna en eða jafnt og 99999,99',
                typeError: 'Sláðu inn peningalegt gildi',
            },
            redemptionPointBlock: {
                moreThan: 'Innlausnareining verður að vera meiri en núll',
            },
            valuePerKwh: {
                moreThan: 'Gildi verður að vera meira en núll',
            },
        },
    },
    amenitys: {
        title: 'Þjónustur: ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Þjónustur',
        manageamenitys: 'Sjá um þjónustu',
        chargeStationsList: 'Hleðslustöðvar',
        chargeLocation: 'Hleðslustaðir',
        amenityTranslationNote:
            'Vinsamlega sláðu inn upplýsingar um þjónustu fyrir kerfisstjórnendur/bílstjóra á svæði viðkomandi tungumáls. Hafi engar upplýsingar verið skráðar fyrir ákveðið tungumál sýnir kerfið staðlaðar upplýsingar',
        label: {
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            name: 'Nafn',
            imageUpload: 'Tákn (34 X 34)',
            language: 'Tungumál',
            image: 'Tákn',
            description: 'Lýsing',
            default_search: 'Sjálfgefin leit',
            status: 'Staða',
            delete: 'Eyða',
            csvFile: 'CSV-skrá',
            importAmenityHeader: 'Flytja inn þjónustur',
            chargeLocation: {
                name: 'Nafn',
                type: 'Gerð',
                address: 'Heimilisfang',
                city: 'Borg',
                postal_code: 'Póstnúmer',
                modifiedDate: 'Dagsetning breytingar',
                action: 'Aðgerð',
            },
            charge_station_name: 'Charge_Station_Name',
            charge_point: 'Charge_Point',
            charge_location_name: 'Charge_Location_Name',
            latitude: 'Breiddargráða',
            longitude: 'Lengdargráða',
            location_address: 'Location_Address',
            amenities: 'Þjónustur',
            amenity_type: 'Gerð þjónustu',
        },
        placeholder: {
            name: 'Nafn',
            description: 'Lýsing',
            file: 'Veldu CSV-skrá',
            select: {
                status: 'Velja stöðu',
                amenity_type: 'Velja gerð',
            },
        },
        columns: {
            name: 'Nafn',
            description: 'Lýsing',
            status: 'Staða',
            action: 'Aðgerð',
            amenity_type: 'Gerð',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            action: 'Aðgerð',
            edit: 'Breyta',
            add: 'Bæta við',
            back: 'Til baka',
            save: 'Vista',
            cancel: 'Hætta við',
            delete: 'Eyða',
            yes: 'Já',
            no: 'Nei',
            disable: 'Afvirkja',
            enable: 'Virkja',
            import: 'Flytja inn',
        },
        errors: {
            common: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
            name: {
                valid: 'Vinsamlega sláðu inn gilt nafn',
            },
            image: {
                fileType: 'Hægt er að hlaða upp .jpg-,.png-, .svg og .jpeg-skrám.',
                dimensions: 'Tákn verður að vera 34 X 34',
                required: 'Tákn vantar',
            },
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
        },
    },
    vehicle: {
        title: 'Bifreið: ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Bifreiðar',
        columns: {
            name: 'Nafn',
            registerNo: 'Skráningarnr.',
            make: 'Tegund',
            model: 'Gerð',
            chargeType: 'Tegund hleðslu',
            batteryCapacity: 'Rafhlöðurýmd',
            consumption: 'Eyðsla',
        },
        placeholder: {
            nameEmail: 'Nafn/netfang',
            makeModelRegistrationNo: 'Útgáfa/gerð/skráningarnr',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
        },
    },
    incompleteSessions: {
        title: 'Óloknar lotur: ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Óloknar lotur',
        placeholder: {
            nameOrEmail: 'Nafn/netfang',
            locationOrStation: 'Staður/stöð',
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
            status: 'Velja stöðu',
            comment: 'Sláðu inn athugasemdirnar þínar',
        },
        label: {
            invalid: 'Ógilt',
            generateCDR: 'Búa til CDR',
            totalEnergy: 'Samtals orka',
            totalCost: 'Samtals kostnaður',
            comment: 'Sláðu inn athugasemdirnar þínar',
            cancelCDR: 'Hætta við CDR',
        },
        columns: {
            name: 'Nafn',
            location: 'Staðsetning',
            sessionId: 'Auðkenni lotu',
            startDate: 'Upphafsdagsetning',
            modifiedDate: 'Dagsetning breytingar',
            time: 'Tími',
            energy: 'orka </b> (kWh',
            cost: 'Kostnaður',
            status: 'Staða',
            action: 'Aðgerð',
        },
        button: {
            action: 'Aðgerð',
            generateCDR: 'Búa til CDR',
            search: 'Leita',
            reset: 'Endurstilla',
            save: 'Vista',
            cancel: 'Hætta við',
            yes: 'Já',
            no: 'Nei',
            cancelCDR: 'Hætta við CDR',
        },
        error: {
            max: 'Hámark 250 stafir',
        },
        message: {
            cancelCDRMessage: 'Ertu viss um að þú viljir hætta við lotu?',
            cancelBulkCDRMessage: 'Ertu viss um að þú viljir hætta við lotu valinna skráa?',
            selectCDR: 'Vinsamlega veldu óloknar lotur',
        },
    },
    ocpiSessions: {
        title: 'OCPI lotur: ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Lotur',
        placeholder: {
            nameOrEmail: 'Nafn/netfang',
            locationOrStation: 'Staður/stöð',
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
            status: 'Velja stöðu',
            comment: 'Sláðu inn athugasemdirnar þínar',
        },
        columns: {
            name: 'Nafn',
            location: 'Staðsetning',
            sessionId: 'Auðkenni lotu',
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
            time: 'Tími',
            energy: 'orka </b> (kWh',
            cost: 'Kostnaður',
            status: 'Staða',
            action: 'Aðgerð',
            vehicleNumber: 'Númer ökutækis',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            complete: 'Ljúka',
        },
        label: {
            complete: 'Ljúka',
            completeSessions: 'Ljúka hleðslulotum',
        },
        message: {
            completeConfirmMessage: 'Viltu ljúka við hleðslulotuna?',
            stopBulkSessionsMessage: 'Viltu ljúka við valdar hleðslulotur?',
            selectSession: 'Vinsamlega veldu hleðslulotur',
        },
    },
    organisation: {
        title: 'Stjórna stofnun: ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Stofnun',
        manageOrganisation: 'Stjórna stofnun',
        label: {
            name: 'Nafn',
            description: 'Lýsing',
            address: 'Heimilisfang',
            city: 'Borg',
            county: 'Hérað',
            postal_code: 'Póstnúmer',
            contact_person: 'Sambandsaðili',
            email: 'Netfang',
            phone_number: 'Símanr.',
            payment_mode: 'Greiðslustilling',
            payment_schedule: 'Greiðsluáætlun',
            user_group_ids: 'Notendahópar',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            amount: 'Inneignarmörk',
            po_number: 'PO-númer',
            finance_account_number: 'Bankareikningsnúmer',
            account_contact_email: 'Tengiliðsnetfang aðgangs',
            remaining_credit: 'Eftirstandandi inneign (%)',
            remoteChargePassword: 'Lykilorð til að hefja fjarhleðslu',
            is_deleted: 'Hefur verið eytt',
            yes: 'Já',
            deleted: 'Eytt',
            dailySpendLimit: 'Dagleg eyðslumörk',
            weeklySpendLimit: 'Vikuleg eyðslumörk',
            monthlySpendLimit: 'Eyðslumörk almanaksmánaðar',
            defaultSpendLimitGroup: 'Stöðluð eyðslumörk - hópur',
            updateSpendLimitAssociation: 'Stöðluð eyðslumörk - hópur samtaka',
            promotionUpdate: 'Kynningaruppfærsla',
            currentPromotion: 'Núverandi kynning',
            newPromotion: 'Ný kynning',
        },
        placeholder: {
            name: 'Nafn',
            name_or_email_or_contact_person: 'Nafn/tengiliðsaðili/netfang',
            description: 'Lýsing',
            address: 'Heimilisfang',
            city: 'Borg',
            county: 'Hérað',
            postal_code: 'Póstnúmer',
            contact_person: 'Sambandsaðili',
            email: 'Netfang',
            phone_number: 'Símanr.',
            select: {
                status: 'Velja stöðu',
                payment_mode: 'Veldu greiðslustilling',
                payment_schedule: 'Veldu greiðsluáætlun',
                user_group_ids: 'Veldu notendahóp',
            },
            amount: 'Inneignarmörk',
            po_number: 'PO-númer',
            finance_account_number: 'Bankareikningsnúmer',
            remaining_credit: 'Eftirstandandi inneign (%)',
            remoteChargePassword: 'Lykilorð til að hefja fjarhleðslu',
            enableSpendLimit: 'Virkja eyðslumörk',
            defaultSpendLimitGroup: 'Velja stöðluð eyðslumörk hóps',
            selectCurrentPromotion: 'Velja núverandi kynningu',
            selectNewPromotion: 'Velja nýja kynningu',
        },
        columns: {
            name: 'Nafn',
            contact_Person: 'Sambandsaðili',
            email: 'Netfang',
            payment_mode: 'Greiðslustilling',
            payment_schedule: 'Greiðsluáætlun',
            created_date: 'Búið til þann',
            status: 'Staða',
            action: 'Aðgerð',
            remote_charge_password: 'Lykilorð til að hefja fjarhleðslu',
            promotion: 'Kynning',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            action: 'Aðgerð',
            edit: 'Breyta',
            add: 'Bæta við',
            back: 'Til baka',
            save: 'Vista',
            cancel: 'Hætta við',
            delete: 'Eyða',
            yes: 'Já',
            no: 'Nei',
            enable: 'Virkja',
            disable: 'Afvirkja',
            permission: 'API-heimild',
            assignSpendLimitGroup: 'Úthluta eyðslumarkahópi',
        },
        errors: {
            name: {
                valid: 'Vinsamlega sláðu inn gilt nafn',
            },
            contact_person: {
                valid: 'Vinsamlega sláðu inn gildan tengilið',
            },
            email: {
                required: 'Vinsamlega sláðu inn netfang',
                email: 'Vinsamlega sláðu inn gilt netfang.',
            },
            phoneNo: {
                required: 'Vinsamlega sláðu inn símanúmerið þitt',
                match: 'Vinsamlega sláðu inn gilt símanúmer',
            },
            amount: {
                moreThan: 'Upphæð verður að vera meiri en 0',
                maxcredit: 'Hámarki kreditaðgangs náð',
            },
            po_number: {
                valid: 'Vinsamlega sláðu inn gilt PO-númer',
            },
            finance_account_number: {
                valid: 'Vinsamlega sláðu inn gilt reikningsnúmer',
            },
            account_contact_email: {
                required: 'Vinsamlega sláðu inn að minnsta kosti eitt netfang',
                maxLimit: 'Hámarki náð fyrir tengiliðsnetfang aðgangs',
            },
            remaining_credit: {
                match: 'Vinsamlega sláðu inn gildar eftirstandandi eftirstöðvar',
                maxCredit: 'Hámarks eftirstandandi inneign má ekki vera meiri en 100',
                minCredit: 'Lágmarks eftirstandandi inneign má ekki vera minni en 0',
            },
            value: {
                moreThan: 'Gildi verður að vera meira en 0',
                lessThan: 'Gildi verður að vera minna en eða jafnt og 5000',
                number: 'Gildi verður að vera tölustafir',
                lessThanWeekly: 'Gildið verður að vera minna en eða jafnt og vikulegu eyðsluhámarki',
                lessThanMonthly: 'Gildið verður að vera minna en eða jafnt og mánaðarlegu eyðsluhámarki',
            },
            spend_limit: {
                moreThan: 'Vikuleg eyðslumörk verða að vera meiri en dagleg eyðslumörk',
                lessThan: 'Dagleg eyðslumörk verða að vera minni en vikuleg eyðslumörk',
            },
            address: 'lágmark 10 stafir',
            addressValid: 'Vinsamlega sláðu inn gilt heimilisfang',
            user_group: {
                required: 'Vinsamlega veldu að minnsta kosti einn notendahóp',
            },
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
            assignAllDriversToDefaultGroup:
                'Viltu úthluta öllum bílstjórum þessarar stofnunar sjálfgefnum eyðslumarkahópi?',
            updatePromotionConfirmMessage: 'Ertu viss um að þú viljir uppfæra kynningu fyrir valdar stofnanir?',
            selectOneRecord: 'Vinsamlega veldu að minnsta kosti eina stofnun til að uppfæra kynningu',
            promotionAssignMessage: 'Nýrri gjaldskrá verður gefin út um eftirfarandi kynningar:',
        },
        permission: {
            header: 'API-heimild',
            label: {
                description: 'Lýsing',
                action: 'API',
            },
        },
    },
    transactionLogs: {
        title: 'Færsluskrár: ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Færsluskrár',
        placeholder: {
            page: 'Veldu síðu',
            email: 'Netfang',
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
            fieldName: 'Heiti reits',
            content: 'Efnisinnihald',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
        },
        label: {
            tableName: 'Heiti töflu',
            fieldName: 'Heiti reits',
            oldValue: 'Gamalt gildi',
            newValue: 'Nýtt gildi',
            user: 'Notandi',
            logDate: 'Dagsetning skrár',
            action: 'Aðgerð',
            goToPage: 'Fara á síðu',
        },
    },
    organisationAccountBalance: {
        title: 'Reikningsstaða stofnunnar : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Reikningsstaða stofnunar',
        manageUser: 'Stjórna reikningsstöðu stofnunar',
        columns: {
            currentBalance: 'Núverandi innistæða',
            closingBalance: 'Lokunarstaða',
            availableCredit: 'Inneign í boði',
            unbilledAmount: 'Órukkuð upphæð',
            name: 'Nafn',
            contact_Person: 'Sambandsaðili',
            email: 'Netfang',
            payment_mode: 'Greiðslustilling',
            payment_schedule: 'Greiðsluáætlun',
            balance: 'Upphæð',
            status: 'Staða',
            action: 'Aðgerð',
            refund: 'Breyta reikningsstöðu',
        },
        placeholder: {
            name: 'Nafn/tengiliðsaðili/netfang',
            description: 'Athugasemd',
            amount: 'Sláðu inn kredit-/debetupphæð',
            select: {
                status: 'Velja stöðu',
                payment_mode: 'Greiðslustilling',
                payment_schedule: 'Greiðsluáætlun',
            },
            invoice: 'Velja reikning',
        },
        label: {
            description: 'Athugasemd',
            amount: 'Sláðu inn kredit-/debetupphæð',
            payment_settlement: 'Breyting inneignar - beiðni',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            invoice: 'Reikningur',
        },
        button: {
            search: 'Leita',
            cancel: 'Hætta við',
            save: 'Vista',
            add: 'Bæta við',
            edit: 'Breyta',
            reset: 'Endurstilla',
            action: 'Aðgerð',
            send_for_approval: 'Senda til samþykkis',
            accept: 'Samþykkja',
        },
        errors: {
            amount: {
                moreThan: 'Upphæð verður að vera meiri/minni en 0',
                maxcredit: 'Hámarki kreditaðgangs náð',
                maxdebit: 'Hámarki debetaðgangs náð',
            },
        },
    },
    driverAward: {
        rewardTitle: 'Umbunarinneign - ##COMPANY_BRAND_NAME## Hraðhleðsla bíla í Bretlandi',
        approvalRequest: 'Samþykktar umbunarstöður - ##COMPANY_BRAND_NAME## Hraðhleðsla bíla í Bretlandi',
        rewards: 'Umbunarstaða',
        approvalRequests: 'Samþykktar reikningsstöður',
        label: {
            name: 'Nafn',
            email: 'Netfang',
            iVRewardPromotion: 'IV umbunarkynning',
            balance: 'Upphæð',
            status: 'Staða',
            action: 'Aðgerð',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            location: 'Staðsetning',
            date: 'Dagsetning',
            energy: 'Orka (kWh)',
            cost: 'Kostnaður',
            rewardPoint: 'Umbunarstig',
            rewardSettelemant: 'Umbunargreiðsla',
            description: 'Lýsing',
            credit: 'Kredit',
            debit: 'Debet',
            iVRewardSettelemant: 'Umbun - greiðsla',
            amount: 'Upphæð',
            request_by: 'Umbeðið af',
            request_date: 'Beðið um þann',
            review_by: 'Yfirfarið af',
            review_date: 'Yfirfarið þann',
            review_comment: 'Athugasemdir umsagnaraðila',
            approvalRequest: 'Samþykktarbeiðni',
            enterComments: 'Sláðu inn athugasemdirnar þínar',
            transaction_date: 'Dagsetning færslu',
            debit_credit: 'Debet/kredit',
            type: 'Gerð',
            requested_by_comment: 'Umbeðið af athugasemdum',
            volts: 'Volt',
            commentsFrom: 'Athugasemdir frá',
            approve: 'Samþykkja',
            decline: 'Hafna',
            federatedAccount: 'Gerð stofnanaaðgangs',
        },
        placeholder: {
            nameOrEmail: 'Nafn/netfang',
            selectIVAwardPromotion: 'Velja IV umbunarkynningu',
            selectStatus: 'Velja stöðu',
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
            description: 'Lýsing',
            volts: 'Volt',
            enterComments: 'Sláðu inn athugasemdirnar þínar',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            save: 'Vista',
            cancel: 'Hætta við',
            decline: 'Hafna',
            approve: 'Samþykkja',
            send_for_approval: 'Senda til samþykkis',
        },
        errors: {
            type: {
                required: 'Kredit eða debet greiðslunnar',
            },
            volts: {
                typeError: 'Sláðu inn gild volt',
                moreThan: 'Volt verða að vera fleiri/færri en 0',
            },
            status: {
                selectApprovalOrReject: 'Samþykkja/hafna þessari beiðni.',
            },
        },
    },
    organisationdashboard: {
        title: 'Skjáborð stofnunnar: ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Skjáborð stofnunar',
        dashboard: 'Skjáborð',
        label: {
            filter: 'Sía',
            organisation: 'Stofnun',
            selectOrganisations: 'Velja stofnun',
            dateRange: 'Tímabil',
            driverGroup: 'Bílstjórahópar',
            drivers: 'Bílstjóri/bifreið',
            selectDriver: 'Velja bílstjóra/bifreið',
            selectDriverGroup: 'Velja bílstjórahópa',
            month: 'Mánuður',
            year: 'Ár',
            day: 'Dagur',
            week: 'Vika',
            userSessionTitle: 'Lotur ökumanns',
            userSessions: 'Lotur ökumanns',
            totalIncomeTitle: 'Heildar innkoma',
            income: 'Innkoma',
            energy: 'Orka',
            energyTitle: 'Heildarorka (kWh)',
            selectAll: 'Velja allt',
            totalRFIDCards: 'Samtals RFID-kort',
            available: 'Í boði',
            allocated: 'Úthlutað',
            duplicate: 'Afrita',
            disabled: 'Óvirkt',
            rfid: 'RFID',
            totalDriverAccounts: 'Samtals aðgangar bílstjóra',
            driver: 'Ökumenn',
            enabled: 'Virkt',
            pending: 'Í bið',
            deleted: 'Eytt',
            topTenDriverVehicles: '10 mest notuðu bílstjórar/bifreiðar',
            driverAccount: 'Ökumaður',
            vehicle: 'Bifreið',
            driverName: 'Nafn bílstjóra',
            vehicleNumber: 'Númer ökutækis',
            kwhUsage: 'kWh notkun',
            dateRangeLabel: 'Tímabil:',
            both: 'Bæði',
            nameorvehicleno: 'Nafn/bifreið nr.',
            type: 'Gerð',
        },
        button: {
            apply: 'Bæta við',
            clear: 'Hreinsa',
            syncData: 'Samstilla gögn',
            search: 'Leita',
            reset: 'Endurstilla',
        },
    },
    organisationtransactions: {
        headerTitle: 'Færslur stofnunar - ##COMPANY_BRAND_NAME## : Hraðhleðsla bíla í Bretlandi',
        invoiceHeader: 'Reiknings upplýsingar- ##COMPANY_BRAND_NAME## Hraðhleðsla bíla í Bretlandi',
        invoiceTitle: 'Reikningsupplýsingar',
        title: 'Færslur stofnunar',
        transaction: 'Færsla',
        columns: {
            location: 'Staðsetning',
            date: 'Dagsetning',
            time: 'Tími',
            cost: 'Kostnaður',
            energy: 'Orka',
            action: 'Aðgerð',
            remark: 'Athugasemdir',
            amount: 'Upphæð',
            closing: 'Lokar',
            transaction: 'Auðkenni færslu',
            name: 'Nafn',
            credit: 'Kredit',
            debit: 'Debet',
            vehicleNumber: 'Númer ökutækis',
            invoiceNumber: 'Númer reiknings',
            comment: 'Athugasemd',
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
        },
        csvHeader: {
            transaction: 'Transaction_ID',
            publicCardId: 'Public_Card_ID',
            stationId: 'Station_ID',
            transactionStartDate: 'Transaction_Start_Date',
            transactionEndDate: 'Transaction_End_Date',
            stationAddress: 'Station_Address',
            driverAccountId: 'Driver_Account_ID',
            vat_amount: 'VAT_Amount',
            stationName: 'Station_Name',
            kwh: 'kWh_Delivered',
            price_per_kwh: 'Price_Per_kWh',
            net_value: 'Net_Value',
            vat_rate: 'VAT_Rate',
            gross_value: 'Gross_Value',
            invoiceNumber: 'Invoice_Number',
            driverName: 'Driver_Name',
        },
        form: {
            charge: 'Er að hlaða',
            payment: 'Greiðsla',
            month: 'Mánuður',
        },
        label: {
            exportAll: 'Flytja allt út',
            amount: 'Upphæð',
            driverName: 'Bílstjóra-/bifreiðanr.',
            station: 'Stöð',
            kwh: 'kWh',
            price_per_kwh: 'Verð/kWh',
            net_value: 'Net_Value',
            vat_rate: 'VSK-gjald',
            gross_value: 'Heildarverðgildi',
            totalBeforeVAT: 'Samtals fyrir VSK',
            VatAt: 'VSK',
            VatRate: 'VSK-gjald:',
            totalNetAmount: 'Samtals upphæð',
            subTotal: 'Millisamtala',
            adjustedAmount: 'Leiðrétt upphæð',
            grandTotal: 'Samtals',
            totalFee: 'Samtals gjald',
            invoiceNumber: 'Númer reiknings',
            invoiceDate: 'Dagsetning reiknings',
            transaction: 'Auðkenni færslu',
            name: 'Nafn',
            date: 'Dagsetning',
            publicCardId: 'Almennt kortaauðkenni',
            stationId: 'Auðkenni stöðvar',
            transactionStartDate: 'Upphafsdagur færslu',
            transactionEndDate: 'Lokadagur færslu',
            stationAddress: 'Heimilisfang stöðvar',
            driverAccountId: 'Aðgangsauðkenni bílstjóra',
            vat_amount: 'VSK-upphæð',
            stationName: 'Heiti stöðvar',
            status: 'Staða',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            back: 'Til baka',
            export: 'Flytja út',
        },
        placeholder: {
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
            startDateFrom: 'Upphafsdagsetning frá',
            startDateTo: 'Upphafsdagsetning til',
            select: {
                organisation: 'Velja stofnun',
                invoice: 'Velja númer reiknings',
            },
        },
        message: {
            noDataToExport: 'Engin gögn til staðar til að flytja út.',
            organisation: {
                required: 'Vinsamlega veldu stofnun',
            },
            selectRecordToExport: 'Veldu skrár til að flytja út.',
        },
    },
    driverVehicleAccount: {
        title: 'Bílstjóra-/bifreiðaaðgangar : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Bílstjóra-/bifreiðaaðgangar',
        managedriver: 'Sjá um bílstjóra/bifreið',
        importHeader: 'Hlaða upp nýjum aðgöngum með RFID-kortum',
        importUpdateStatusHeader: 'Virkja/slökkva á aðgöngum',
        importUpdateSpendGroupAssociation: 'Uppfæra eyðslumörk bílstjóra hópsamtök',
        placeholder: {
            name: 'Nafn/netfang/bifreið nr.',
            rfidCardNo: 'RFID-kortanr.',
            driverGroups: 'Velja bílstjórahópa',
            status: 'Velja stöðu',
            first_name: 'Skírnarnafn',
            last_name: 'Föðurnafn',
            email: 'Netfang',
            vehicle_no: 'Nr, ökutækis',
            driverGroup: 'Velja bílstjórahópa',
            accountType: 'Velja gerð aðgangs',
            publicRFIDCardNo: 'Sláðu inn almennt RFID-kortanr.',
            languagePreference: 'Valið tungumál',
        },
        label: {
            name: 'Nafn',
            email: 'Netfang',
            vehicleNo: 'Nr, ökutækis',
            group: 'Hópur',
            createdDate: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            cancelled: 'Hætt við',
            deleted: 'Eytt',
            delete: 'Eyða',
            first_name: 'Skírnarnafn',
            last_name: 'Föðurnafn',
            vehicle_no: 'Nr, ökutækis',
            driverGroup: 'Bílstjórahópar',
            accountType: 'Reikningstegund',
            assignRFIDCard: 'Úthluta RFID-korti',
            rfidCard: 'RFID-kort',
            publicRFIDCardNo: 'Sláðu inn almennt RFID-kortanr.',
            assign: 'Úthluta',
            allocatedRFIDCards: 'Ráðstafa RFID-kortum',
            file: 'CSV-skrá',
            clickHere: 'Smelltu hér',
            downloadTemplate: 'til að hlaða niður sniðmáti',
            errosInImportedFile: 'Villur',
            driverVehicleNo: 'Bílstjóra-/bifreiðanr.',
            driverVehicleDetails: 'Upplýsingar bílstjóra/bifreiðar',
            error: 'Villa',
            pending: 'Í bið',
            card_allocated: 'RFID-korti úthlutað',
            driver: 'Bílstjóri (aðgangur í gegnum Fleet App)',
            vehicle: 'Bifreið (í gegnum RFID-aðgang)',
            note: 'Athugið:',
            accountSetupNote:
                'Aðgangshafi verður að ljúka við uppsetningu aðgangs inn 24 klukkustunda í gegnum ##COMPANY_BRAND_NAME## Fleet Appið með tímabundna lykilorðinu sem veitt var í tölvupósti.',
        },
        button: {
            import: 'Flytja inn',
            add: 'Bæta við',
            search: 'Leita',
            reset: 'Endurstilla',
            edit: 'Breyta',
            enable: 'Virkja',
            disable: 'Afvirkja',
            delete: 'Eyða',
            yes: 'Já',
            no: 'Nei',
            back: 'Til baka',
            save: 'Vista',
            cancel: 'Hætta við',
            assignRFIDCard: 'Úthluta RFID-korti',
            assign: 'Úthluta',
            action: 'Aðgerð',
            done: 'Lokið',
            sendEmail: 'Senda tölvupóst',
            enableDisableAccounts: 'Virkja/slökkva á aðgöngum',
            export: 'Flytja út',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
            sendMailConfirmMessage: 'Ertu viss um að þú viljir senda tölvupóst?',
            mailSentSuccessMessage: 'Tókst að senda tölvupóst.',
        },
        errors: {
            invalidEmail: 'Vinsamlega sláðu inn gilt netfang.',
            invalidFirstName: 'Vinsamlega sláðu inn gilt fornafn.',
            invalidLastName: 'Vinsamlega sláðu inn gilt eftirnafn.',
            invalidVehicleNo: 'Vinsamlega sláðu inn gilt bifreiðarnr.',
            common: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
        },
        account_type: {
            driver: 'Ökumaður',
            vehicle: 'Bifreið',
        },
        columns: {
            public_rfid_card_no: 'Kortanr.',
            allocatedBy: 'Úthlutað af',
            allocatedDate: 'Dagsetning úthlutunar',
            status: 'Staða',
        },
    },
    chargingHistory: {
        header: 'Hleðslulotur - ##COMPANY_BRAND_NAME## : Hraðhleðsla bíla í Bretlandi',
        title: 'Hleðslulotur',
        label: {
            exportAll: 'Flytja út',
            location: 'Staðsetning',
            date: 'Dagsetning',
            milesAdded: 'Mílum bætt við',
            time: 'Tími',
            cost: 'Kostnaður',
            energy: 'Orka',
            action: 'Aðgerð',
            remark: 'Athugasemdir',
            name: 'Nafn',
            vehicleNo: 'Nr, ökutækis',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            back: 'Til baka',
        },
        placeholder: {
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
            startDateFrom: 'Upphafsdagsetning frá',
            startDateTo: 'Upphafsdagsetning til',
            driver: 'Nafn/netfang/bifreið nr.',
            selectDriverGroup: 'Velja bílstjóra-/bifreiðahópa',
        },
        errors: {
            noDataToExport: 'Engin gögn til staðar til að flytja út.',
            selectRecordToExport: 'Veldu skrár til að flytja út.',
            common: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
        },
    },
    paymentHistory: {
        header: 'Greiðslusaga- ##COMPANY_BRAND_NAME## : Hraðhleðsla bíla í Bretlandi',
        title: 'Greiðslusaga',
        invoiceHeader: 'Reiknings upplýsingar- ##COMPANY_BRAND_NAME## Hraðhleðsla bíla í Bretlandi',
        invoiceTitle: 'Reikningsupplýsingar',
        label: {
            remark: 'Athugasemdir',
            credit: 'Kredit',
            debit: 'Debet',
            closing: 'Lokar',
            transaction: 'Auðkenni færslu',
            name: 'Nafn',
            date: 'Dagsetning',
            amount: 'Upphæð',
            driverName: 'Bílstjóra-/bifreiðanr.',
            station: 'Stöð',
            kwh: 'kWh',
            price_per_kwh: 'Verð/kWh',
            net_value: 'Net_Value',
            vat_rate: 'VSK-gjald',
            gross_value: 'Heildarverðgildi',
            totalBeforeVAT: 'Samtals fyrir VSK',
            VatAt: 'VSK',
            totalFee: 'Samtals gjald',
            invoiceNumber: 'Númer reiknings',
            invoiceDate: 'Dagsetning reiknings',
            publicCardId: 'Almennt kortaauðkenni',
            stationId: 'Auðkenni stöðvar',
            transactionStartDate: 'Upphafsdagur færslu',
            transactionEndDate: 'Lokadagur færslu',
            stationAddress: 'Heimilisfang stöðvar',
            driverAccountId: 'Aðgangsauðkenni bílstjóra',
            vat_amount: 'VSK-upphæð',
            stationName: 'Heiti stöðvar',
        },
        csvHeader: {
            transaction: 'Transaction_ID',
            publicCardId: 'Public_Card_ID',
            stationId: 'Station_ID',
            transactionStartDate: 'Transaction_Start_Date',
            transactionEndDate: 'Transaction_End_Date',
            stationAddress: 'Station_Address',
            driverAccountId: 'Driver_Account_ID',
            vat_amount: 'VAT_Amount',
            stationName: 'Station_Name',
            kwh: 'kWh_Delivered',
            price_per_kwh: 'Price_Per_kWh',
            net_value: 'Net_Value',
            vat_rate: 'VAT_Rate',
            gross_value: 'Gross_Value',
            invoiceNumber: 'Invoice_Number',
            driverName: 'Driver_Name',
        },
        placeholder: {
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            export: 'Flytja út',
        },
        errors: {
            noDataToExport: 'Engin gögn til staðar til að flytja út.',
            selectRecordToExport: 'Veldu skrár til að flytja út.',
        },
    },
    configurations: {
        title: 'Stillingar : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Stillingar',
        columns: {
            name: 'Nafn',
            value: 'Verðgildi',
            description: 'Lýsing',
            system_type: 'Kerfisgerð',
            modifiedBy: 'Breytt af',
            modifiedDate: 'Dagsetning breytingar',
            action: 'Aðgerð',
        },
        button: {
            save: 'Vista',
            cancel: 'Hætta við',
            reset: 'Endurstilla',
            search: 'Leita',
            action: 'Aðgerð',
            edit: 'Breyta',
        },
        note: 'VIÐVÖRUN: Breytingar á þessum stillingum geta haft töluverð áhrif á árangur vettvangsins. Hafðu samband við kerfisstjóra ef þú ert í vafa.',
        errors: {
            maxLengthString: 'Vinsamlega sláðu inn gildi að hámarki',
            maxLengthStringCharacters: 'bókstafi',
            maxLengthNUmberCharacters: 'tölustafi',
            valueBetween: 'Vinsamlega sláðu inn gildi frá',
            valueGraterThen: 'Vinsamlega sláðu inn gildi sem jafngildir eða er hærra en',
            valueMention: 'Vinsamlega veittu gildi á uppgefnu sviði',
        },
        placeholder: {
            value: 'Sláðu inn gildi',
            description: 'Sláðu inn lýsingu',
            name: 'Nafn',
            valueSearch: 'Verðgildi',
            descriptionSearch: 'Lýsing',
            referenceCode: 'Tilvísunarnúmer',
            systemType: 'Veldu kerfisgerð',
        },
        label: {
            value: 'Verðgildi',
            dataType: 'Gerð gagna',
            description: 'Lýsing',
            system: 'KERFI',
            driver: 'REKILL',
            admin: 'KERFISSTJÓRI',
            referenceCode: 'Tilvísunarnúmer',
        },
    },
    rfidRequests: {
        title: 'RFID-kortabeiðnir - ##COMPANY_BRAND_NAME## : Hraðhleðsla bíla í Bretlandi',
        header: 'RFID-kortabeiðnir',
        placeholder: {
            nameEmail: 'Nafn/netfang',
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
            publicCardNo: 'Sláðu inn almennt RFID-kortanr.',
            enterComments: 'Sláðu inn athugasemdirnar þínar',
            status: 'Velja stöðu',
            publicRFIDCardNo: 'Sláðu inn almennt RFID-kortanr.',
            scanReqQR: 'Skannaðu QR-kóða sem er prentaður á bréf',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            save: 'Vista',
            cancel: 'Hætta við',
            add: 'Bæta við',
            done: 'Lokið',
            action: 'Aðgerð',
            assign: 'Úthluta',
            downloadPdf: 'Sækja PDF beiðna',
            downloadPdfSelected: 'Sækja PDF valinna beiðna',
            downloadPendingApprovedPdf: 'Sækja PDF allra beiðna sem eru í bið og eru samþykktar',
        },
        columns: {
            name: 'Nafn',
            email: 'Netfang',
            requestedDate: 'Umbeðin dagsetning',
            noofCardReq: 'Fjöldi umbeðinna korta',
            noofCardAllocated: 'Fjöldi úthlutaðra korta',
            requestStatus: 'Staða beiðni',
            status: 'Staða',
            driverStatus: 'Staða rekils',
            action: 'Aðgerð',
            public_rfid_card_no: 'Kortanr.',
            allocatedBy: 'Úthlutað af',
            allocatedDate: 'Dagsetning úthlutunar',
            federated_account_type: 'Gerð stofnanaaðgangs',
        },
        label: {
            reviewRequest: 'Umsagnarbeiðni',
            assignRFID: 'RFID-kort',
            processRFIDRequest: 'Ferlisbeiðni',
            noofCardRequested: 'Fjöldi umbeðinna korta',
            noofCardAllocated: 'Fjöldi úthlutaðra korta',
            approved: 'Samþykkja',
            declined: 'Hafna',
            publicCardNo: 'Sláðu inn almennt RFID-kortanr.',
            enterComments: 'Sláðu inn athugasemdirnar þínar',
            requestStatus: 'Staða beiðni',
            assignRFIDCards: 'Úthluta RFID-kortum',
            publicRFIDCardNo: 'Sláðu inn almennt RFID-kortanr.',
            allocatedRFIDCards: 'Ráðstafa RFID-kortum',
            address: 'Heimilisfang',
            scanReqQR: 'Skannaðu QR-kóða sem er prentaður á bréf',
            name: 'Nafn',
            requestId: 'Auðkenni beiðni',
            scanHistory: 'Skönnunarsaga',
        },
        message: {
            requestProcessed: 'Tókst að vinna úr beiðni',
        },
        errors: {
            approveReject: 'Vinsamlega samþykkið/hafnið þessari beiðni',
            selectAnyRecord: 'Vinsamlega veldu að minnsta kosti eina skrá til að sækja sem PDF.',
            reqNumTypeError: 'Vinsamlega sláðu inn gilt auðkenni beiðni',
        },
        pdfText: {
            dear: 'Kæri/kæra',
            instavolt: '##COMPANY_BRAND_NAME##',
            companyNumber: 'Númer fyrirtækis',
            line1: 'Þakka þér fyrir að sækja um RFID-kort í gegnum ##COMPANY_BRAND_NAME## appið, hér er kortið þitt.',
            line2: 'Vinsamlega fylgdu eftirfarandi skrefum til að virkja kortið þitt:',
            step1: '1. Skráðu þig inn í appið',
            step2: '2. Veldu „Stillingar“ í valmyndinni',
            step3: '3. Veldu valmöguleikann „RFID-kortin mín“',
            step4: '4. Veldu hnappinn „Bæta við RFID-korti“',
            step5: '5. Sláðu inn kortanúmerið sem prentað er á kortið og veldu hnappinn „Halda áfram“',
            step6: '6. Kortið þitt hefur nú verið virkjað og hægt er að nota það í næstu hleðslulotu',
            line3: 'Vissir þú að þú getur fengið umbun í hvert skipti sem þú hleður? Fáðu eitt Volt fyrir hvert kWh sem þú notar. Þegar þú hefur safnað nægilega mörgum Voltum er hægt að innleysa þau og nota til að kaupa hleðslulotur í kerfinu.',
            line4: 'Takk fyrir að hlaða hjá okkur.',
            line5: '##COMPANY_BRAND_NAME## teymið',
            line6: 'Heimsklassa hleðslukerfi rafbíla í Bretlandi',
        },
    },
    RFIDCardFleets: {
        title: 'RFID-kort : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'RFID-kort',
        placeholder: {
            name: 'Nafn/netfang/númer ökutækis',
            manufacturer: 'Framleiðandi',
            public_card_id: 'Auðkenni almenns korts',
            status: 'Velja stöðu',
            mifare_uid: 'Mifare UID',
        },
        label: {
            name: 'Nafn',
            manufacturer: 'Framleiðandi',
            part_id: 'Auðkenni hluta',
            public_card_id: 'Auðkenni almenns korts',
            private_card_id: 'Auðkenni einkakorts',
            created_date: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            delete: 'Eyða',
            remove: 'Fjarlægja tengingu',
            reinstate: 'Endurúthluta',
            activated: 'Virkjað',
            available: 'Í boði',
            duplicate: 'Afrita',
        },
        button: {
            search: 'Leita',
            cancel: 'Hætta við',
            add: 'Bæta við',
            assing: 'Úthluta RFID-korti',
            import: 'Flytja inn skrá',
            save: 'Vista',
            edit: 'Breyta',
            reset: 'Endurstilla',
            yes: 'Já',
            no: 'Nei',
            enabled: 'Virkja',
            disabled: 'Afvirkja',
            action: 'Aðgerð',
            back: 'Til baka',
            enable: 'Virkja',
            disable: 'Afvirkja',
            getCredentials: 'Fá skilríki',
            delete: 'Eyða',
            remove: 'Fjarlægja tengingu',
            reinstate: 'Endurúthluta',
            exportAll: 'Flytja allt út',
        },
        message: {
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            removeConfirmMesage: 'Ertu viss um að þú viljir fjarlægja tengingu RFID-korts við aðgang',
            reinstateConfirmMessage: 'Ertu viss um að þú viljir endurráðstafa RFID-korti?',
        },
        insert: {
            header: 'Sjá um RFID-kort',
            placeholder: {
                manufacturer: 'Nafn framleiðanda',
                part_id: 'Auðkenni hluta',
                public_card_id: 'Auðkenni almenns korts',
                private_card_id: 'Auðkenni einkakorts',
                mifare_uid: 'Mifare UID',
            },
            label: {
                manufacturer: 'Framleiðandi',
                part_id: 'Auðkenni hluta',
                public_card_id: 'Auðkenni almenns korts',
                private_card_id: 'Auðkenni einkakorts',
                mifare_uid: 'Mifare UID',
            },
            errors: {
                common: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
                name: {
                    valid: 'Sláðu inn gilt nafn',
                },
                code: {
                    valid: 'Sláðu inn gildan kóða',
                },
                url: {
                    valid: 'Hlekkur verður að vera gildur hlekkur',
                },
            },
        },
        assignCards: {
            header: 'Úthluta RFID-korti',
            label: {
                driver: 'Bílstjóri/bifreið',
            },
            button: {
                yes: 'Úthluta',
                no: 'Hætta við',
            },
            form: {
                driver: 'Bílstjóri/bifreið',
                placeholder: {
                    driver: 'Velja bílstjóra/bifreið',
                },
            },
        },
        disableCards: {
            header: 'Afvirkja',
            header2: 'Ertu viss um að þú viljir afvirkja?',
            placeholder: {
                comment: 'Slá inn athugasemd',
            },
            label: {
                comment: 'Athugasemd',
            },
            button: {
                yes: 'Já',
                no: 'Nei',
            },
        },
        importCards: {
            header: 'Flytja inn RFID-kort',
            placeholder: {
                file: 'Veldu CSV-skrá',
            },
            label: {
                file: 'CSV-skrá',
            },
            button: {
                yes: 'Flytja inn',
                no: 'Hætta við',
            },
            errors: {
                common: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
                file: {
                    fileType: 'Hægt er að hlaða upp skrár með „.csv“-skráarheiti',
                },
            },
        },
        importCardsDetails: {
            header: 'Upplýsingar um innflutning RFID korta',
            label: {
                unSuccessfullImport: 'Eftirfarandi kort er ekki hægt að flytja inn',
                successfullImport: 'Eftirfarandi kort hafa verið flutt inn með góðum árangri',
                failerReason: 'Ástæða bilunar',
                publicCardId: 'Auðkenni opinbers korts',
            },
            message: {
                defualtErrorMessage: 'Vandamál kom upp við innflutning eftirfarandi korta.',
            },
        },
    },
    myProfile: {
        title: 'Aðgangurinn minn : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Aðgangurinn minn',
        subheader: {
            details: 'Persónuupplýsingar',
            security: 'Öryggi',
            password: 'Lykilorð',
        },
        label: {
            firstName: 'Skírnarnafn',
            lastName: 'Föðurnafn',
            email: 'Netfang',
            phoneNo: 'Símanr.',
            currentPassword: 'Núverandi lykilorð',
            newPassword: 'Nýtt lykilorð',
            confirmPassword: 'Endurstaðfestu lykilorð',
            mfaAuthentication: '2 þátta auðkenning',
            authentication: 'Auðkenning',
            securityCode: 'Öryggisnúmer',
            languagePreference: 'Valið tungumál',
        },
        placeholder: {
            firstName: 'Skírnarnafn',
            lastName: 'Föðurnafn',
            email: 'Netfang',
            phoneNo: 'Símanr.',
            currentPassword: 'Núverandi lykilorð',
            newPassword: 'Nýtt lykilorð',
            confirmPassword: 'Endurstaðfestu lykilorð',
            securityCode: 'Öryggisnúmer',
            languagePreference: 'Valið tungumál',
        },
        button: {
            save: 'Vista',
            cancel: 'Hætta við',
            update: 'Uppfæra',
            ok: 'Í lagi',
        },
        toast: {
            profileSuccess: 'Það tókst að uppfæra aðgang.',
            profileError: 'Aðgangur var ekki uppfærður. Vinsamlega reyndu aftur síðar.',
            passwordChange: 'Það tókst að breyta lykilorði.',
            passwordErr: 'Lykilorði var ekki breytt. Vinsamlega reyndu aftur síðar.',
            passwordWrong: 'Núverandi lykilorð er rangt.',
            securityStop: '2 þátta auðkenning var stöðvuð.',
            error: 'Eitthvað fór úrskeiðis. Vinsamlega reyndu aftur síðar.',
            securitySetupSuccess: 'Það tókst að setja upp 2 þátta auðkenningu.',
            securitySetupError: '2 þátta auðkenning var ekki sett upp. Vinsamlega reyndu aftur síðar.',
            securityCodeInvalid: 'Rangur öryggiskóði.',
        },
        errors: {
            securityCode: {
                match: 'Vinsamlega sláðu inn gildan kóða',
                inValid: 'Vinsamlega sláðu inn 6 tölustafa kóða',
            },
            password: {
                confirmPasswordMatch: 'Nýtt lykilorð og staðfest lykilorð verða að stemma.',
            },
        },
    },
    apiCredentials: {
        title: 'API skilríki : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'API-skilríki',
        button: {
            generate: 'Framkalla tákn',
            regenerate: 'Endurframkalla tákn',
            yes: 'Já',
            no: 'Nei',
        },
        note_no_permission:
            'Þú ert ekki með réttindi til að nálgast API. Hafðu samband við kerfisstjóra ##COMPANY_BRAND_NAME## til að fá aðgang.',
        note_generte_token:
            'Þú getur framkallað táknið með því að smella á „Framkalla tákn“. Þú getur notað táknið til að fá aðgang að API.',
        note: 'Þú getur endurframkallað táknið með því að smella á „Endurframkalla tákn“. Þú getur notað táknið til að fá aðgang að API.',
        label: {
            token: 'Tákn',
            generate: 'Framkalla tákn',
            regenerate: 'Endurframkalla tákn',
        },
        message: {
            regenerateConfirmMesage:
                'Ertu viss um að þú viljir endurframkalla tákn? </br> Þegar táknið er endurframkallað verður gamla táknið ógilt og þú getur ekki fengið aðgang að API með gamla tákninu.',
            generateConfirmMesage: 'Ertu viss um að þú viljir framkalla tákn?',
        },
    },
    cookiePolicy: {
        text: 'Þessi vefsíða notar vafrakökur til að bæta upplifun notenda. Með því að nota síðuna okkar staðfestir þú að þú hafir lesið og skilið',
        action: 'Vafrastefnuna okkar',
        iAccept: 'Ég samþykki',
    },
    paymentconfig: {
        title: 'Greiðsla - ##COMPANY_BRAND_NAME## : Hraðhleðsla bíla í Bretlandi',
        header: 'Greiðsla',
        processingNote: 'Vinsamlega hinkrið á meðan unnið er úr færslunni þinni',
        purchaseOrderNote: 'Greiðslutímabil ##PAYMENT_SCHEDULE## í gangi. Næsta dagsetning greiðslu er :',
        description: 'Greiðsla til ##COMPANY_BRAND_NAME##',
        note: 'Bakgrunnsstarf mun virkjast einu sinni í viku til að hreinsa eftirstandandi reikninga fyrir EV-hleðslu sem bílstjórar/bifreiðar framkvæma',
        addReplaceCardNote:
            'Vinsamlega athugið að með því að bæta greiðslukorti við aðganginn þinn verður debet fært á ##CURRENCY_SYMBOL_WITH_VALUE## sem verður kreditfært á ##COMPANY_BRAND_NAME## innistæðuna þína.',
        label: {
            currentBalance: 'Núverandi innistæða',
            closingBalance: 'Lokunarstaða',
            availableCredit: 'Inneign í boði',
            unbilledAmount: 'Órukkuð upphæð',
            cardTitle: 'Nafn á korti',
            cardNumber: 'Kortanúmer',
            expiry: 'Gildistími',
            note: 'Athugasemd :',
            CSC: 'CSC',
            cardSecurityCode: '(Öryggisnúmer korts)',
            charityDonation: 'Áheit til góðgerðamála',
            roundUp: 'Námunda upp',
            topUp: 'Fylla á',
            expires: 'Rennur út',
            charity: 'Góðgerðastofnun',
        },
        placeholder: {
            cardTitle: 'Nafn á korti',
            cardNumber: '1234 1234 1234 1234',
            CSC: 'CSC',
            topUpAmount: '00.00',
        },
        button: {
            save: 'Vista',
            edit: 'Breyta',
            replace: 'Skipta út',
            back: 'Til baka',
            payNow: 'Greiða núna',
        },
        errors: {
            CSC: {
                min: 'Sláðu inn að minnsta kosti 3 tölustafa kóða.',
            },
            topupAmount: {
                min: 'Upphæð til góðgerðamála verður að vera hærri en eða jafnt og 0,1',
            },
            cardNumber: {
                inValid: 'Ógilt kortanúmer',
            },
            commonError: 'Villa kom upp við að vinna úr beiðninni þinni, vinsamlega reyndu aftur síðar.',
            transactionFailed: 'Færslunni þinni var hafnað, vinsamlega reyndu aftur síðar.',
        },
        message: {
            cardSaved: 'Kortaupplýsingar hafa verið vistaðar',
        },
    },
    refundRequest: {
        title: 'Samþykktar úttektir - ##COMPANY_BRAND_NAME## Hraðhleðsla bíla í Bretlandi',
        header: 'Samþykktar úttektir',
        accountInfoNote: 'Aðgangsupplýsingar slegnar inn til að ljúka við úttektina:',
        completeConfirmNote:
            'Ljúktu aðeins við þessa úttektarbeiðni ef þú hefur gjaldfært bankareikning bílstjóra fyrir uppgefnu upphæðinni. Viltu halda áfram?',
        bulkCompleteConfirmNote:
            'Ljúktu aðeins við þessar úttektarupphæðir ef þú hefur gjaldfært bankareikning bílstjóra fyrir uppgefnu upphæðinni. Viltu halda áfram?',
        declineConfirmNote:
            'Vinsamlega gakktu úr skugga um að þú hafir slegið inn viðeigandi ástæðu fyrir höfnun beiðninnar þar eð þessar upplýsingar verða sendar til viðskiptavinarins.  Viltu halda áfram?',
        bulkDeclineConfirmNote:
            'Vinsamlega gakktu úr skugga um að þú hafir slegið inn viðeigandi ástæðu fyrir höfnun beiðninnar þar eð þessar upplýsingar verða sendar til viðskiptavinarins.  Viltu halda áfram?',
        label: {
            name: 'Nafn',
            reviewRequest: 'Umsagnarbeiðni',
            driverName: 'Nafn bílstjóra',
            driverEmail: 'Netfang bílstjóra',
            requestedDate: 'Umbeðin dagsetning',
            action: 'Aðgerð',
            amount: 'Upphæð',
            refundRequested: 'Óskað eftir úttekt',
            status: 'Staða',
            accountNumber: 'Reikningsnúmer',
            sortCode: 'Flokkunarkóði',
            enterComments: 'Slá inn athugasemd',
            pending: 'Í bið',
            closed: 'Lokað',
            complete: 'Ljúka',
            decline: 'Hafna',
            review_by: 'Yfirfarið af',
            review_date: 'Yfirfarið þann',
            approvalRequest: 'Samþykkja beiðni',
            processRefundRequest: 'Vinna úr úttektarbeiðni',
            completeRefundRequest: 'Ljúka við úttektarbeiðni',
            bulkCompleteRefundRequest: 'Ljúka við úttektarbeiðnir',
            declineRefundRequest: 'Hafna úttektarbeiðni',
            bulkdeclineRefundRequest: 'Hafna úttektarbeiðnum',
            export: 'Flytja út gögn',
            bulk: 'Í magni',
        },
        button: {
            decline: 'Hafna',
            approve: 'Samþykkja',
            reset: 'Endurstilla',
            search: 'Leita',
            complete: 'Ljúka',
            save: 'Vista',
            cancel: 'Hætta við',
            yes: 'Já',
            no: 'Nei',
        },
        placeholder: {
            selectStatus: 'Velja stöðu',
            enterComments: 'Slá inn athugasemd',
            name: 'Nafn/netfang',
        },
        errors: {
            status: {
                selectApprovalOrReject: 'Vinsamlega ljúkið við/hafnið þessari beiðni.',
            },
            selectWithdrawalApprovals: 'Vinsamlega veldu úttektarbeiðnir',
        },
    },
    termsAndConditionListing: {
        title: 'Skilmálar - ##COMPANY_BRAND_NAME## : Hraðhleðsla bíla í Bretlandi',
        header: 'Skilmálar',
        noteDetails: '*Nauðsynlegt er að samþykkja til að nota/búa til aðgang.',
        label: {
            iAggreeToTermsCondition: 'Ég samþykki',
            note: 'Athugið:',
            termsAndConditions: 'Skilmálar.',
            reviewUpdatedCondition: 'Vinsamlega farið yfir og samþykkið uppfærða notkunarskilmála hér að neðan.',
            name: 'Nafn',
            accepted: 'Samþykkt',
        },
        button: {
            accept: 'Samþykkja',
            next: 'Næsta',
            cancel: 'Hætta við',
        },
        errors: {
            acceptTermCondition: 'Vinsamlega samþykkið * nauðsynlega notkunarskilmála til að halda áfram.',
        },
    },
    adminDashboard: {
        title: 'Heim : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Skjáborð',
        formtitle: 'Staðfesting forms',
        label: {
            filter: 'Sía',
            reportTags: 'Tilkynna merki',
            driverGroup: 'Bílstjórahópar',
            selectDriverGroup: 'Velja bílstjórahópa',
            selectTags: 'Velja merki',
            dateRange: 'Tímabil',
            month: 'Mánuður',
            year: 'Ár',
            day: 'Dagur',
            week: 'Vika',
            userSessionTitle: 'Lotur ökumanns',
            userSessions: 'Lotur ökumanns',
            totalIncomeTitle: 'Heildar innkoma',
            income: 'Innkoma',
            transactionTitle: 'Meðalfærsla',
            transaction: 'Færsla',
            energy: 'Orka',
            energyTitle: 'Heildarorka (kWh)',
            failedPaymentTitle: 'Fjöldi misheppnaðra greiðslna',
            failedPayment: 'Misheppnuð greiðsla',
            driverCountTitle: 'Fjöldi bílstjóra',
            driver: 'Ökumaður',
            accumulatedVolts: 'Samansöfnuð Volt',
            claimedVolts: 'Sótt Volt',
            outStandingFailPayment: 'Eftirstandandi misheppnuð greiðsla',
            outStandingFailedPaymentTitle: 'Eftirstandandi misheppnaðar greiðslur',
            voltsLiability: 'Ábyrgð Volta',
            voltsAccumulatedTitle: 'Uppsöfnuð Volt',
            volts: 'Volt',
            voltsClaimedTitle: 'Volt sótt',
            lapsedVolts: 'Útrunnin Volt',
            totalNoOfDriverAccount: 'Fjöldi bílstjóraaðganga',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            badDebtor: 'Slæmur skuldari',
            cancelled: 'Hætt við',
            deleted: 'Eytt',
            fake_account: 'Gerviaðgangur',
            numberOfReferees: 'Fjöldi notanda í gegnum tilvísun',
            numberOfReferrers: 'Fjöldi notanda sem hafa sent tilvísun',
            referralPayment: 'Tilvísunargreiðslur (notandi sem sendi og notandi sem tók við)',
            referrer: 'Notandi sem sendi tilvísun',
            referee: 'Notandi sem tók við tilvísun',
            moneySpent: 'Fjármagni eytt af notendum sem tóku við tilvísunum',
            referralBonus: 'tilvísunarbónus',
            referralPromotion: 'Tilvísunarkynning',
            overnightAutomated: 'Sjálfvirkt yfir nótt',
            customerManual: 'Handbók viðskiptavinar',
            pending: 'Í bið',
            patnerPromoClicksCount: 'Smellufjöldi á kynningar samstarfsaðila',
            clicksCount: 'Fjöldi smella',
            clicksCountMessage:
                'Veldu einn eða marga valmöguleika til að sýna fjölda smella á kynningum samstarfsaðila',
            individualDrivers: 'Virkjaðir aðgangar bílstjóra',
            organisationDrivers: 'Virkjaðir aðgangar stofnana',
            individualAndOrgDriverCount: 'Virkjaðir aðgangar: Bílstjórar sbr. stofnanir',
            alerts: 'Tilkynningar',
            alertsCountTitle: 'Fjöldi tilkynninga',
            premiumSubscriptions: 'Premium-áskriftir',
            activeSubscriptions: 'Fjöldi virkra premium-áskrifta',
            newSubscriptions: 'Nýjar áskriftir',
            cancelledSubscriptions: 'Uppsagnir áskrifta',
            subscriptions: '(Áskriftir)',
        },
        placeholder: {
            patnerPromotions: 'Veldu eina eða fleiri kynningar samstarfsaðila til að sýna gögn',
        },
        button: {
            apply: 'Bæta við',
            clear: 'Hreinsa',
            syncData: 'Samstilla gögn',
        },
    },
    footer: {
        version: 'Útgáfa',
        copyRightText: 'Allur réttur áskilinn',
    },
    cardReader: {
        title: 'Kortalesarar : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Kortalesarar',
        manageCardReader: 'Sjá um kortalesara',
        importHeader: 'Flytja inn kortalesara',
        button: {
            import: 'Flytja inn',
            add: 'Bæta við',
            back: 'Til baka',
            save: 'Vista',
            cancel: 'Hætta við',
            edit: 'Breyta',
            action: 'Aðgerð',
            delete: 'Eyða',
            search: 'Leita',
            reset: 'Endurstilla',
            disable: 'Afvirkja',
            duplicate: 'Afrita',
            active: 'Virkt',
            chargeStation: 'Hleðslustöðvar',
            yes: 'Já',
            no: 'Nei',
            claimCardReader: 'Krefjast óúthlutaðra kortalesara',
            claim: 'Krafa',
        },
        label: {
            description: 'Lýsing',
            latitude: 'Breiddargráða',
            longitude: 'Lengdargráða',
            serialNumber: 'Raðnúmer',
            endPoint: 'Endapunktur',
            createdDate: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
            delete: 'Eyða',
            csvFile: 'CSV-skrá',
            clickHere: 'Smelltu hér',
            downloadTemplate: 'til að hlaða niður sniðmáti',
            evse_id: 'EVSE ID',
            error: 'Villa',
            errorDetail: 'Villuupplýsingar',
            failureReason: 'Ástæða bilunar',
            id: 'Auðkenni kortalesara',
        },
        placeholder: {
            description: 'Lýsing',
            latitude: 'Breiddargráða',
            longitude: 'Lengdargráða',
            serialNumber: 'Raðnúmer',
            endPoint: 'Hnekkja endapunkti',
            selectStatus: 'Velja stöðu',
        },
        errors: {
            latitude: {
                min: 'Breiddargráða verður að vera á milli -90,0 og 90,0',
                max: 'Breiddargráða verður að vera á milli -90,0 og 90,0',
                number: 'Breiddargráða verður að vera í tölustöfum',
            },
            longitude: {
                min: 'Lengdargráða verður að vera á milli -180,0 og 180,0',
                max: 'Lengdargráða verður að vera á milli -180,0 og 180,0',
                number: 'Lengdargráða verður að vera í tölustöfum',
            },
            serial_number: {
                valid: 'Sláðu inn gilt raðnúmer',
            },
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            duplicateConfirmMesage: 'Ertu viss um að þú viljir afrita?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
            activeConfirmMesage: 'Ertu viss um að þú viljir virkja?',
        },
        assign: {
            header: 'Hleðslustöðvar',
            headerModal: 'Hleðslustöð',
            placeholder: {
                name: 'Sláðu inn nafn',
                address: 'Heimilisfang',
                tags: 'Velja merki',
            },
            label: {
                add: 'Bæta við',
                address: 'Heimilisfang',
                city: 'Borg',
                name: 'Nafn',
                type: 'Gerð',
                physical_reference: 'Áþreifanleg tilvísun',
                postcode: 'Póstnúmer',
                action: 'Aðgerð',
                delete: 'Eyða',
            },
            button: {
                delete: 'Eyða',
            },
            message: {
                deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            },
        },
    },
    cardScheme: {
        title: 'Kortaáætlanir : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Kortaáætlanir',
        manageCardScheme: 'Stjórna kortaáætlunum',
        label: {
            TransIdSeed: 'Auðkenni færslustrengs',
            keybEncrKey: 'KeyB dulkóðunarlykill',
            transIdEncrKey: 'Dulkóðunarlykill færsluauðkennis',
            emspCode: 'EMSP-kóði',
            endPoint: 'Endapunktur',
            createdDate: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
            delete: 'Eyða',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
        },
        button: {
            import: 'Flytja inn',
            add: 'Bæta við',
            back: 'Til baka',
            save: 'Vista',
            cancel: 'Hætta við',
            edit: 'Breyta',
            action: 'Aðgerð',
            delete: 'Eyða',
            search: 'Leita',
            reset: 'Endurstilla',
            disable: 'Afvirkja',
            enable: 'Virkja',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
        },
        placeholder: {
            emspCode: 'EMSP-kóði',
            keybEncrKey: 'KeyB dulkóðunarlykill',
            transIdEncrKey: 'Dulkóðunarlykill færsluauðkennis',
            TransIdSeed: 'Auðkenni færslustrengs',
        },
        errors: {
            emsp_code: {
                valid: 'Sláðu inn gildan EMSP-kóða',
            },
            transaction_id_seed: {
                valid: 'Sláðu inn gild færslustrengsauðkenni',
                min: 'Færslustrengsauðkenni má ekki vera minna en 0',
                max: 'Hámarki færslustrengs auðkennis náð',
            },
        },
    },
    fleetProfile: {
        orgProfile: 'Aðgangur stofnunar',
        message: {
            success: 'Tókst að uppfæra aðgang stofnunar',
        },
    },
    dataAggregator: {
        title: 'Gagnasafnarar : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Gagnasafnarar',
        button: {
            add: 'Bæta við',
            search: 'Leita',
            reset: 'Endurstilla',
            enable: 'Virkja',
            disable: 'Afvirkja',
            edit: 'Breyta',
            yes: 'Já',
            no: 'Nei',
            action: 'Aðgerð',
            back: 'Til baka',
            save: 'Vista',
            cancel: 'Hætta við',
            syncDataAggregatorAPIKeys: 'Samstilla API-lykla við notkunaráætlanir',
        },
        placeholder: {
            name: 'Nafn',
            status: 'Velja stöðu',
        },
        label: {
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            name: 'Nafn',
            party_id: 'Auðkenni aðila',
            country_code: 'Landkóði',
            version_url: 'Útgáfuhlekkur',
            created_date: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
        },
        message: {
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
        },
        insert: {
            header: 'Stjórna gagnasöfnurum',
            errors: {
                common: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
                name: {
                    valid: 'Sláðu inn gild heiti gagnasafnara',
                },
                party_id: {
                    valid: 'Sláðu inn gilt auðkenni aðila',
                },
                country_code: {
                    valid: 'Sláðu inn gildan landkóða',
                },
                version_url: {
                    url: 'Útgáfuhlekkur verður að vera gildur hlekkur',
                },
                token: {
                    valid: 'Sláðu inn gilt tákn',
                },
            },
            placeholder: {
                name: 'Nafn',
                party_id: 'Auðkenni aðila',
                country_code: 'Landkóði',
                version_url: 'Útgáfuhlekkur gagnasafnara',
                token_a: 'Tákn A',
                token_b: 'Tákn B',
                token_c: 'Tákn C',
                emsp: 'EMSP',
                access_group: 'Aðgangshópur',
                usagePlan: 'Notkunaráætlun',
            },
            label: {
                name: 'Nafn',
                party_id: 'Auðkenni aðila',
                country_code: 'Landkóði',
                version_url: 'Útgáfuhlekkur',
                emsp: 'EMSP',
                token_a: 'Tákn A',
                token_b: 'Tákn B',
                token_c: 'Tákn C',
                allow_locations_to_be_extracted: 'Aðeins heimila útdrátt staðsetninga úr EMPS',
                allow_receive_location_update:
                    'Heimila móttöku PUT (Upphafs ræsing) og PATCH (Stöðuuppfærsla) staðsetningaruppfærslur',
                access_group: 'Aðgangshópur',
                allow_tariff_extraction: '	Innihalda Toll',
                usagePlan: 'Notkunaráætlun',
            },
        },
    },
    accessGroups: {
        title: 'Aðgangshópar : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Aðgangshópar',
        manageAccessGroup: 'Stjórna aðgangshópum',
        label: {
            createdDate: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
            delete: 'Eyða',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            name: 'Nafn',
            description: 'Lýsing',
            access_control_type: 'Gerð aðgangsstjórnunar',
            allow_public_access: 'Leyfa almennan aðgang',
            managed_by_organisation: 'Stjórnað af stofnun',
            override_tariff: 'Hnekkja gjaldskrá',
            yes: 'Já',
            no: 'Nei',
            access_code: 'Aðgangskóði',
            deleted: '(Eytt)',
        },
        button: {
            enable: 'Virkja',
            disable: 'Afvirkja',
            action: 'Aðgerð',
            edit: 'Breyta',
            delete: 'Eyða',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            add: 'Bæta við',
            search: 'Leita',
            reset: 'Endurstilla',
            back: 'Til baka',
            save: 'Vista',
            cancel: 'Hætta við',
            deleted: '(Eytt)',
            chargeStation: 'Hleðslustaðir',
            yes: 'Já',
            no: 'Nei',
            drivers: 'Ökumenn',
        },
        placeholder: {
            name: 'Nafn',
            selectStatus: 'Velja stöðu',
            allow_public_access: 'Leyfa almennan aðgang',
            description: 'Lýsing',
            access_control_type: 'Gerð aðgangsstjórnunar',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
        },
        assign: {
            header: 'Hleðslustaðir',
            headerModal: 'Hleðslustaðir',
            placeholder: {
                name: 'Sláðu inn nafn',
                address: 'Heimilisfang',
                tags: 'Velja merki',
                postal_code: 'Póstnúmer',
                power_type: 'Veldu rafmagnstegund',
            },
            label: {
                add: 'Bæta við',
                address: 'Heimilisfang',
                city: 'Borg',
                name: 'Nafn',
                type: 'Gerð',
                physical_reference: 'Áþreifanleg tilvísun',
                postcode: 'Póstnúmer',
                action: 'Aðgerð',
                delete: 'Eyða',
            },
            button: {
                delete: 'Eyða',
            },
            message: {
                deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            },
        },
        driverAssign: {
            header: 'Ökumenn',
            headerModal: 'Ökumenn',
            placeholder: {
                email: 'Netfang',
                status: 'Staða',
            },
        },
        errors: {
            name: {
                valid: 'Sláðu inn gilt nafn',
            },
        },
    },
    accessGroupRequests: {
        title: 'Aðgangshópabeiðnir : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Aðgangshópabeiðnir',
        columns: {
            name: 'Nafn',
            email: 'Netfang',
            federated_account_type: 'Gerð stofnanaaðgangs',
            requested_access_group: 'Umbeðinn aðgangshópur',
            requested_date: 'Umbeðin dagsetning',
            driver_status: 'Staða rekils',
            request_status: 'Staða beiðni',
            action: 'Aðgerð',
        },
        button: {
            action: 'Aðgerð',
            search: 'Leita',
            reset: 'Endurstilla',
            save: 'Vista',
            cancel: 'Hætta við',
        },
        label: {
            review_request: 'Umsagnarbeiðni',
            requested_access_group: 'Umbeðinn aðgangshópur:',
            approve: 'Samþykkja',
            decline: 'Hafna',
            enterComments: 'Athugasemdir',
        },
        placeholder: {
            nameEmail: 'Nafn/netfang',
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
            status: 'Velja stöðu',
            enterComments: 'Sláðu inn athugasemdirnar þínar',
        },
        errors: {
            approveReject: 'Vinsamlega samþykkið/hafnið þessari beiðni',
        },
    },
    payByWeb: {
        title: 'Pay By Web : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Borga á netinu',
        columns: {
            evse_id: 'EVSE-auðkenni',
            status: 'Staða',
            physical_reference: 'Áþreifanleg tilvísun',
            location_name: 'Heiti staðsetningar',
            location_address: 'Staðsetning heimilisfangs',
            location_city: 'Staðsetning borgar',
            location_postal_code: 'Póstnúmer staðsetningar',
            pay_by_web_active: 'Borga á netinu',
            action: 'Aðgerð',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            enablePayByWeb: 'Virkja greiðslu á netinu',
            disabledPayByWeb: 'Slökkva á greiðslu á netinu',
            submit: 'Senda',
            cancel: 'Hætta við',
        },
        label: {
            enabled: 'Virkja',
            disabled: 'Afvirkja',
            manageUniqueCode: 'Sjá um einkvæman kóða',
            uniqueCode: 'Einkvæmur kóði',
        },
        message: {
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja greiðslu á netinu fyrir valdar stöðvar?',
            disableConfirmMesage: 'Ertu viss um að þú viljir slökkva á greiðslu á netinu fyrir valdar stöðvar?',
        },
        placeholder: {
            evse_id: 'EVSE-auðkenni',
            status: 'Velja stöðu',
            physical_reference: 'Áþreifanleg tilvísun',
            location_name: 'Heiti staðsetningar',
            location_address: 'Staðsetning heimilisfangs',
        },
        errors: {
            unique_code: {
                valid: 'Sláðu inn gildan einkvæman kóða',
            },
        },
    },
    driverDebt: {
        title: 'Skuld bílstjóra : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Skuld bílstjóra',
        button: {
            generate1Letters: 'Búðu til bréf 1',
            generate2Letters: 'Búðu til bréf 2',
            download: 'Hlaða niður',
            strikeOneLetter: 'Bréf fyrstu áminningar',
            strikeTwoLetter: 'Bréf síðari áminningar',
            generateStrikeOneLetters: 'Framkalla bréf fyrstu áminningar',
            generateStrikeTwoLetters: 'Framkalla bréf síðari áminningar',
            runHistory: 'Framkalla áminningarbréf - Saga',
            pastLetters: 'Fyrri bréf',
            regenerateLetters: 'Endurframkalla bréf',
            refreshPastLetters: 'Endurhlaða fyrri bréf',
        },
        label: {
            pastLetters: 'Fyrri bréf',
            inProgress: '(í vinnslu)',
            noDataFound: 'Engin gögn fundust.',
            dynamicFields: 'Breytilegir reitir',
            clickToCopy: '(smelltu til að afrita aths.)',
            driverName: 'Nafn bílstjóra',
            driverDebt: 'Skuld bílstjóra',
            debtAge: 'Aldur skuldar',
            driverEmail: 'Netfang bílstjóra',
            driverAddress: 'Heimilisfang bílstjóra',
            date: 'Dagsetning',
            clickToCopyTooltip: 'Smelltu til að afrita',
            regenerate: 'Endurframkalla',
            regenerateLetters: 'Endurframkalla bréf',
            letterTemplate: 'Bréfasniðmát',
            cancel: 'Hætta við',
            reportGenerationInProgress: '(Framköllun tilkynningar í vinnslu)',
            copyDriverIds: 'Smelltu til að afrita auðkenni bílstjóra',
        },
        columns: {
            run: 'Keyrsla nr.',
            driverIDs: 'Auðkenni bílstjóra gjaldgeng fyrir þessa umferð',
            runTimestamp: 'Tímastimpill keyrslu',
            strikeType: 'Gerð áminningar',
            initiatedByUser: 'Notandi sem hóf keyrsluna',
            regenerate: 'Endurframkalla',
            action: 'Aðgerð',
            relatedRun: 'Tengt keyrslu nr.',
            date: 'Dagsetning',
            file: 'Skrá',
            templateUsed: 'Sniðmát notað',
            generatedBy: 'Framkallað af',
        },
        placeholder: {
            strikeOneLetter: 'Veldu bréf fyrri áminningar',
            strikeTwoLetter: 'Veldu bréf síðari áminningar',
        },
    },
    fleetAccessGroups: {
        title: 'Aðgangshópabeiðnir : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
    },
    emailLogs: {
        title: 'Netfangaskrár : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Netfangaskrár',
        columns: {
            recipient: 'Viðtakandi',
            subject: 'Viðfangsefni',
            deliveryStatus: 'Staða sendingar',
            errorMessage: 'Villuskilaboð',
            createdDate: 'Stofndags.',
        },
        label: {
            viewError: 'Sýna villu',
        },
        placeholder: {
            recipient: 'Viðtakandi',
            subject: 'Viðfangsefni',
            deliveryStatus: 'Staða sendingar',
            errorMessage: 'Villuskilaboð',
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
        },
    },
    alerts: {
        title: 'OCPI villuskrár : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'OCPI-villuskrár',
        columns: {
            api: 'hlekkur',
            api_call_type: 'Gerð API-kalls',
            api_request_type: 'Gerð beiðni',
            response_code: 'Svarkóði',
            error_message: 'Villuskilaboð',
            alert_type: 'Gerð viðvörunar',
            created_date: 'Stofndags.',
            request_body: 'Meginmál beiðni',
            response_body: 'Svar beiðni',
        },
        placeholder: {
            api: 'hlekkur',
            alert_type: 'Gerð viðvörunar',
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
        },
        label: {
            viewDetails: 'Skoða upplýsingar',
            errorLogDetails: 'Upplýsingar OCPI-villuskráar',
        },
    },
    SubscriptionSetting: {
        title: 'Premium-áskriftir : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Premium-áskriftir',
        manageSubscription: 'Sjá um premium-áskrift',
        label: {
            subscription_type: 'Gerð áskriftar',
            subscription_amount: 'Upphæð áskriftar',
            free_subscription_duration: 'Tímabil gjaldfrjálsrar áskriftar',
            created_date: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
            enabled: 'Virkja',
            disabled: 'Afvirkja',
            maximum_routing_call: 'Hámarksfjöld beiniskalla (á mánuði)',
            additional_volts_per_kwh: 'Viðbótar Volt umbun/kWh',
            name: 'Nafn',
            description: 'Lýsing',
            subscriptionImage: 'Mynd premium-áskriftar',
            exportSubscribersList: 'Flytja út lista yfir áskrifendur',
            downloadSubscribersList: 'Sækja áskrifendalista',
        },
        placeholder: {
            subscription_amount: 'Upphæð áskriftar',
            free_subscription_duration: 'Tímabil gjaldfrjálsrar áskriftar (Dagar)',
            maximum_routing_call: 'Hámarksfj. beiniskalla',
            name: 'Nafn',
            status: 'Velja stöðu',
            subscriptionType: 'Veldu gerð áskriftar',
            subscriptionImage: 'Veldu mynd premium-áskriftar',
        },
        button: {
            action: 'Aðgerð',
            disable: 'Afvirkja',
            enable: 'Virkja',
            edit: 'Breyta',
            back: 'Til baka',
            save: 'Vista',
            cancel: 'Hætta við',
            enableDisable: 'Virkja/slökkva á áskrift',
            add: 'Bæta við',
            search: 'Leita',
            reset: 'Endurstilla',
        },
        errors: {
            amount: {
                moreThan: 'Upphæð verður að vera hærri en 1',
                lessThan: 'Upphæð verður að vera lægri en 100',
                number: 'Upphæð verður að vera í tölustöfum',
            },
            duration: {
                moreThan: 'Lengd verður að vera meiri en 1',
                lessThan: 'Lengd verður að vera minni en 180',
            },
            maxRoutingCall: {
                moreThan: 'Hámarksgildi beiðniskalla verður að vera hærra en 1',
                lessThan: 'Hámarksgildi beiðniskalla verður að vera minna en 1000',
            },
            additionalVolts: {
                lessThan: 'Gildi verður að vera minna en eða jafnt og 5',
                number: 'Gildi verður að vera tölustafir',
            },
        },
        message: {
            enableFromConfig:
                'Vinsamlega stilltu fyrst „Virkja premium áskrift“ á „Satt“ í Stillingar > Stillingar til að virkja premium-áskrift',
            disableConfirmMessage:
                'Viðvörun: Með því að slökkva á premium-áskrift er hætt við sjálfvirka endurnýjun allra tengdra bílstjóraaðganga. Ertu viss um að þú viljir afvirkja?',
            enableConfirmMessage: 'Ertu viss um að þú viljir virkja?',
        },
    },
    advertisingDevices: {
        title: 'Auglýsingatæki : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Auglýsingatæki',
        label: {
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            device_name: 'Nafn',
            device_id: 'Auðkenni tækis',
            postal_code: 'Póstnúmer',
            charge_station: 'Hleðslustöð',
            screen_size: 'Skjástærð',
            created_date: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
            delete: 'Eyða',
            operational: 'Starfhæft',
        },
        button: {
            action: 'Aðgerð',
            edit: 'Breyta',
            delete: 'Eyða',
            enabled: 'Virkja',
            disabled: 'Afvirkja',
            add: 'Bæta við',
            reset: 'Endurstilla',
            search: 'Leita',
            back: 'Til baka',
            save: 'Vista',
            cancel: 'Hætta við',
            assignVideos: 'Úthluta myndböndum',
            yes: 'Já',
            no: 'Nei',
            regenerateS3File: 'Endurframkalla S3-skrá',
            mediaTerminalLogs: 'Skrár miðlastöðvar',
        },
        placeholder: {
            device_name: 'Heiti tækis',
            postal_code: 'Póstnúmer',
            charge_station: 'Hleðslustöð',
            selectStatus: 'Velja stöðu',
            screen_size: 'Skjástærð',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
        },
        insert: {
            header: 'Sjá um auglýsingatæki',
            placeholder: {
                device_name: 'Heiti tækis',
                device_id: 'Auðkenni tækis',
                charge_station: 'Hleðslustöð',
                screen_size: 'Skjástærð',
            },
            label: {
                device_name: 'Heiti tækis',
                device_id: 'Auðkenni tækis',
                charge_station: 'Hleðslustöð',
                screen_size: 'Skjástærð',
            },
            errors: {
                common: 'Eitthvað fór úrskeiðis. vinsamlega reynið aftur.',
                name: {
                    valid: 'Sláðu inn gilt nafn',
                },
                device_id: {
                    valid: 'Sláðu inn gilt tækisauðkenni',
                    min: 'Auðkenni tækis verður að vera að minnsta kosti 6 stafir',
                },
            },
        },
        assignVideos: {
            header: 'Myndbönd',
            headerModal: 'Myndbönd',
            label: {
                action: 'Aðgerð',
                delete: 'Eyða',
            },
            placeholder: {
                file_name: 'Skráarnafn',
                description: 'Lýsing',
            },
            message: {
                deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            },
        },
    },
    advertisingVideos: {
        title: 'Auglýsingamyndbönd : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Auglýsingamyndbönd',
        label: {
            file_name: 'Skráarnafn',
            description: 'Lýsing',
            operational_start_date: 'Upphafsdagsetning starfhæfis',
            operational_end_date: 'Lokadagsetning starfhæfis',
            created_date: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
            delete: 'Eyða',
            reviewVideo: 'Forskoða myndband',
            approve: 'Samþykkja',
            reject: 'Hafna',
            videoUpload: 'Myndband',
            comments: 'Athugasemdir',
        },
        button: {
            action: 'Aðgerð',
            edit: 'Breyta',
            delete: 'Eyða',
            enabled: 'Virkja',
            disabled: 'Afvirkja',
            add: 'Bæta við',
            reset: 'Endurstilla',
            search: 'Leita',
            back: 'Til baka',
            save: 'Vista',
            cancel: 'Hætta við',
            reviewVideo: 'Forskoða myndband',
            downloadVideo: 'Hala niður myndbandi',
            assignDevice: 'Úthluta tækjum',
        },
        placeholder: {
            file_name: 'Skráarnafn',
            description: 'Lýsing',
            start_date: 'Upphafsdagsetning starfhæfis',
            end_date: 'Lokadagsetning starfhæfis',
            selectStatus: 'Velja stöðu',
            videoUpload: 'Myndband',
            enterComments: 'Sláðu inn athugasemdirnar þínar',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
        },
        insert: {
            header: 'Sjá um auglýsingamyndband',
            placeholder: {
                description: 'Lýsing',
                operational_start_date: 'Upphafsdagsetning starfhæfis',
                operational_end_date: 'Lokadagsetning starfhæfis',
            },
            label: {
                description: 'Lýsing',
                operational_start_date: 'Upphafsdagsetning starfhæfis',
                operational_end_date: 'Lokadagsetning starfhæfis',
            },
        },
        errors: {
            status: {
                message: {
                    selectApprovalOrReject: 'Vinsamlega samþykktu/hafnaðu þessari beiðni.',
                },
            },
            name: {
                valid: 'Sláðu inn gilt nafn',
            },
            file_name: {
                fileType: 'Hægt er að hlaða upp .mp4-, .flv-, .wmv-, .mpeg-, .avi- og .3gp-skrám',
                uploadError: 'Villa við að hlaða upp myndbandsskrá',
                required: 'Myndbandsskrá vantar',
                fileNameLength: 'Skráarnafn má vera að hámarki 15 stafir',
            },
            file_size: 'Hámarksstærð skráar til að hlaða upp er',
        },
        assignDevices: {
            header: 'Tæki',
            headerModal: 'Tæki',
            label: {
                action: 'Aðgerð',
                delete: 'Eyða',
            },
            placeholder: {
                device_name: 'Heiti tækis',
                device_id: 'Auðkenni tækis',
                status: 'Staða',
            },
            message: {
                deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
            },
        },
    },
    advertisingCredentials: {
        title: 'Auglýsingaskilríki : #COMPANY_BRAND_NAME - eMobility þjónustuvettvangur',
        header: 'Auglýsingaskilríki',
        manageCredentials: 'Sjá um auglýsingaskilríki',
        label: {
            bucket_name: 'Nafn fötu',
            region_name: 'Nafn svæðis',
            download_access_key: 'Hala niður aðgangslykli',
            download_secret_key: 'Hala niður leynilykli',
            upload_access_key: 'Hlaða upp aðgangslykli',
            upload_secret_key: 'Hlaða upp leynilykli',
            download_info_object_name: 'Hala niður nafni upplýsingahluts',
            upload_path: 'Hala upp slóð',
            dialog_password: 'Samtalslykilorð',
            expect_bucket_name: 'Nafn viðbúinnar fötu',
            expect_region_name: 'Nafn viðbúins svæðis',
            expect_download_access_key: 'Viðbúið niðurhal aðgangslykils',
            expect_download_secret_key: 'Viðbúið niðurhal leynilykils',
            version_code: 'Útgáfukóði',
            download_url: 'Hala niður hlekk',
            prompt: 'Kvaðning',
            remarks: 'Athugasemdir',
            modified_by: 'Breytt af',
            modified_date: 'Dagsetning breytingar',
            status: 'Staða',
            action: 'Aðgerð',
            enabled: 'Virkja',
            disabled: 'Afvirkja',
        },
        button: {
            action: 'Aðgerð',
            disable: 'Afvirkja',
            enable: 'Virkja',
            edit: 'Breyta',
            back: 'Til baka',
            save: 'Vista',
            cancel: 'Hætta við',
        },
    },
    organisationInvoices: {
        title: 'Reikningar stofnunar : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Reikningar stofnunar',
        label: {
            name: 'Stofnun',
            invoice_id: 'Auðkenni reiknings',
            invoice_value: 'Gildi reiknings',
            invoice_date: 'Dagsetning reiknings',
            action: 'Aðgerð',
            undo: 'Afturkalla',
            undoPayment: 'Afturkalla greiðslu',
            disputed: 'Ágreiningsefni',
            adjustAmount: 'Stilla gildi reiknings',
            paid_value: 'Greitt gildi',
            outstanding: 'Eftirstandandi',
            status: 'Staða',
            comments: 'Athugasemdir',
            original_value: 'Upprunalegt gildi',
        },
        placeholder: {
            name: 'Nafn',
            start_date: 'Upphafsdagsetning',
            end_date: 'Lokadagsetning',
            status: 'Staða',
            organisation: 'Velja stofnun',
        },
        button: {
            search: 'Leita',
            reset: 'Endurstilla',
            action: 'Aðgerð',
            pay: 'Greiða',
            partPay: 'Greiða að hluta',
            undo: 'Afturkalla',
            disputed: 'Ágreiningsefni',
            adjustValue: 'Stilla gildi reiknings',
        },
        errors: {
            amount: {
                moreThan: 'Upphæð verður að vera meiri en 0',
                maxValue: 'Hámarksupphæð aðgangs náð',
                notZero: 'Upphæð verður að vera meiri/minni en 0',
                minValue: 'Lágmarksupphæð aðgangs náð',
                number: 'Upphæð verður að vera í tölustöfum',
            },
            organisation: {
                required: 'Vinsamlega veldu stofnun',
            },
        },
        message: {
            undoConfirmMessage:
                'Ertu viss um að þú viljir fjarlægja greidda upphæð og stilla stöðu á „Eftirstandandi“ fyrir þennan reikning?',
            disputedConfirmMessage: 'Ertu viss um að þú viljir stilla stöðu á „Ágreiningur“ fyrir þennan reikning?',
        },
        payModal: {
            header: 'Greiða',
            partPayHeader: 'Greiða að hluta',
            label: {
                amount: 'Upphæð',
                date_paid: 'Greitt þann',
                comments: 'Athugasemdir',
            },
            placeholder: {
                amount: 'Sláðu inn upphæð',
                date_paid: 'Sláðu inn dagsetningu greiðslu',
                comments: 'Slá inn athugasemd',
            },
            button: {
                accept: 'Samþykkja',
                send_for_approval: 'Senda til samþykkis',
                cancel: 'Hætta við',
                submit: 'Senda',
            },
        },
    },
    mediaTerminalLogs: {
        title: 'Miðlastöðvarskrár : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Skrár miðlastöðvar',
        label: {
            file_name: 'Skráarnafn',
            date_played: 'Spilað þann',
            play_time: 'Spilunartími',
            start_time: 'Upphafstími',
        },
        placeholder: {
            fileName: 'Skráarnafn',
            startDate: 'Upphafsdagsetning',
            endDate: 'Lokadagsetning',
        },
    },
    fleetDriverSpendHistory: {
        title: 'Eyðslumarkasaga: ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Eyðslumarkasaga',
        label: {
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            name: 'Nafn bílstjóra',
            email: 'Netfang bílstjóra',
            type: 'Gerð viðmiðunar',
            spend_limit_exceed_date: 'Farið fram úr eyðslumörkum þann',
            status: 'Staða rekils',
            action: 'Aðgerð',
            export: 'Flytja út',
            onStop: 'Við stöðvun',
            cancelOnStop: 'Hætta við stöðvun',
        },
        button: {
            disable: 'Afvirkja',
            enable: 'Virkja',
            search: 'Leita',
            reset: 'Endurstilla',
            yes: 'Já',
            no: 'Nei',
            back: 'Til baka',
        },
        placeholder: {
            name: 'Nafn bílstjóra',
            email: 'Netfang bílstjóra',
            status: 'Velja stöðu bílstjóra',
            dateFrom: 'Takmarka dagsetningu sem farið er yfir frá',
            dateTo: 'Takmarka dagsetningu sem farið er yfir til',
            type: 'Veldu gerð viðmiðunar',
        },
        message: {
            noDataToExport: 'Engin gögn til staðar til að flytja út.',
            cancelOnStopConfirmation: 'Ertu viss um að þú viljir hætta við að stöðva fyrir þennan bílstjóra?',
        },
    },
    driverDebtorLetters: {
        title: 'Skuldabréf bílstjóra: ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Skuldabréf bílstjóra',
        manageDriverDebtorLetter: 'Sjá um skuldabréf bílstjóra',
        label: {
            reportType: 'Gerð tilkynningar',
            defaultLetter: 'Staðlað sniðmát skuldabréfs',
            content: 'Efnisinnihald',
            enabled: 'Virkt',
            disabled: 'Óvirkt',
            created_date: 'Stofndags.',
            status: 'Staða',
            action: 'Aðgerð',
            delete: 'Eyða',
            dynamicFields: 'Breytilegir reitir',
            copyNotation: '(smelltu til að afrita aths.)',
            clickToCopy: 'Smelltu til að afrita',
            driverName: 'â€¢ Nafn bílstjóra',
            driverDebt: 'â€¢ Skuld bílstjóra',
            debtAge: 'â€¢ Aldur skuldar',
            driverEmail: 'â€¢ Netfang bílstjóra',
            driverAddress: 'â€¢ Heimilisfang bílstjóra',
            date: 'â€¢ Dagsetning',
            uniqueReference: 'â€¢ Einkvæm tilvísun',
            useStandardTemplate: 'Nota staðlað sniðmát',
        },
        column: {
            defaultLetter: 'Sjálfgefið bréf',
        },
        button: {
            setDefaultLetter: 'Stilla sem sjálfgefið',
            enable: 'Virkja',
            disable: 'Afvirkja',
            edit: 'Breyta',
            delete: 'Eyða',
            createDuplicate: 'Búa til afrit',
            save: 'Vista',
            cancel: 'Hætta við',
            preview: 'Forskoða',
        },
        message: {
            setDefaultConfirmMesage: 'Ertu viss um að þú viljir stilla þetta skuldabréf sem sjálfgefið bréf?',
            enableConfirmMesage: 'Ertu viss um að þú viljir virkja?',
            disableConfirmMesage: 'Ertu viss um að þú viljir afvirkja?',
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
        },
        error: {
            emptyContent: 'Vinsamlega búðu til efni til að forskoða bréfasniðmát',
            common: 'Villa kom upp við að vinna úr beiðninni þinni, vinsamlega reyndu aftur síðar.',
            supportedDynamicField1: 'Þessir breytilegu reitir',
            supportedDynamicField2: 'eru aðeins studdir fyrir skuldabréf',
        },
    },
    driverSubscriptions: {
        title: 'Premium-áskriftir bílstjóra : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        header: 'Premium-áskriftir',
        label: {
            subscriptionType: 'Gerð áskriftar',
            subscriptionStartDate: 'Upphafsdagsetning áskriftar',
            subscriptionStatus: 'Staða áskriftar',
            renewalOrExpiryDate: 'Endurnýjun/gildistími',
            voltsCredited: 'Volt lögð inn',
            journeysPlanned: 'Áætlaðar ferðir',
            active: 'Virkt',
            cancelled: 'Hætt við',
            action: 'Aðgerð',
            cancel: 'Hætta við',
            cancelSubscription: 'Hætta við áskrift',
            terminate: 'Ljúka',
            terminateSubscription: 'Ljúka við áskrift',
            freeTrial: 'Ókeypis prufa',
            name: 'Nafn',
            promotion: 'Kynning',
        },
        message: {
            cancelConfirmMessage:
                'Ertu viss um að þú viljir hætta við áskrift þessa notanda? Þetta mun hætta við næstu sjálfvirku endurnýjun áskriftarinnar.',
            terminateConfirmMessage:
                'Ertu viss um að þú viljir ljúka við áskrift þessa notanda? Þetta mun hætta við næstu sjálfvirku endurnýjun og stöðva öll fríðindi sem fylgja þessari áskrift.',
            terminateConfirmMessageWithoutRenew:
                'Ertu viss um að þú viljir ljúka við áskrift þessa notanda? Þetta mun stöðva öll fríðindi sem fylgja þessari áskrift.',
        },
    },
    advertisingDropDownDefaultmessage: 'Sláðu inn að minnsta kosti 3 stafi staða til að birta lista yfir stöðvar',
    rfidcardDropDownDefaultMessage: 'Sláðu inn að minnsta kosti 3 stafi til að birta lista yfir bílstjóra/bifreiðar',
    chargeStationMapDropDownDefaultMessage:
        'Sláðu inn að minnsta kosti 3 stafi hleðslustöðvar til að birta hleðslustöðvar',
    startChargePageDropDownDefaultMessage: 'Sláðu inn stafi staða til að birta lista yfir staði',
    groupGridDropDownDefaultMessage: 'Sláðu inn að minnsta kosti 3 stafi til að birta lista yfir bílstjóra/bifreiðar',
    organisationdashBoardDefaultMessage:
        'Sláðu inn að minnsta kosti 3 stafi til að birta lista yfir bílstjóra/bifreiðar',
    rfidAssigncardDefaultDropDownMessage:
        'Sláðu inn að minnsta kosti 3 stafi af netfangi ökumanns til að birta lista yfir bílstjóra',
    tariffDropDownDefaultMessage: 'Sláðu inn að lágmarki 3 stafi úr gjaldskrá til að birta gjaldskrárlista',
    continueTypingSearch: 'Haltu áfram að skrifa til að rétta af leit',
    limitExceedAddressError: 'Tókst ekki að finna heimilisfangið að þessari stundu',
    noFileChosen: 'Engin skrá valin',
    ChooseFile: 'Velja skrá',
    noOptions: 'Engir valmöguleikar',
    requiredField: 'Reit vantar',
    removeImage: 'Fjarlægja mynd',
    help: 'Aðstoð',
    editor: {
        bold: 'Feitletrað',
        italic: 'Skáletrað',
        underline: 'Undirstrikað',
        strikeThrough: 'Yfirstrikað',
        monospace: 'Jafnstafaletur',
        superscript: 'Brjóstletur',
        subscript: 'Hnéletur',
        blockType: 'Gerð blokkar',
        fontSize: 'Leturstærð',
        font: 'Leturgerð',
        unordered: 'Óraðað',
        ordered: 'Raðað',
        indent: 'Inndregið',
        outdent: 'Útdregið',
        left: 'Vinstrijafnað',
        right: 'Hægrijafnað',
        center: 'Miðjujafnað',
        justify: 'Milliraðað',
        colorPicker: 'Litaval',
        link: 'Hlekkur',
        unlink: 'Aftengja hlekk',
        embedded: 'Innbyggt',
        emoji: 'Táknmynd',
        remove: 'Fjarlægja',
        undo: 'Afturkalla',
        redo: 'Endurgera',
        image: 'Mynd',
    },
    map: {
        zoomIn: 'Þysja inn',
        zoomOut: 'Þysja út',
    },
    InstaVolt: '##COMPANY_BRAND_NAME##',
    apply: 'Bæta við',
    cancel: 'Hætta við',
    noDataFound: 'Því miður! engin gögn fundust',
    globalService: {
        title: 'Skráning alþjóðlegrar þjónustu : ##COMPANY_BRAND_NAME## - eMobility þjónustuvettvangur',
        status: {
            pending:
                'Í samskiptum við alþjóðlegar þjónustur skaltu vinsamlega setja inn upplýsingarnar hér að neðan. Þú getur komið á samskiptum með því að smella á hnappinn „Skrá“.',
            registered:
                'EMSP-vettvangur getur átt í samskiptum við alþjóðlegu þjónusturnar núna. Ef þú átt í vandræðum með samskiptin skaltu vinsamlega slá inn upplýsingarnar hér að neðan og smella á hnappinn „endurskrá“.',
        },
        insert: {
            url: 'vefslóð',
            handshakeToken: 'Handabandstákn',
        },
        placeholder: {
            url: 'vefslóð',
            handshakeToken: 'Handabandstákn',
        },
        label: {
            note: 'Athugið',
            noteValue:
                'Slá þarf inn „Handabandstákn“ í hvert skipti þegar komið er á samskiptum við alþjóðlegar þjónustur. Vinsamlega hafðu samband við kerfisstjóra til að bera kennsl á „Handabandstáknið“.',
            rfidSync: 'RFID-samstilling',
        },
        button: {
            register: 'Skrá',
            reRegister: 'Endurskrá',
        },
        error: {
            errorWhileCreatingGlobalService: 'Villa við að búa til alþjóðlega þjónustu.',
            errorWhileUpdatingGlobalService: 'Villa við að uppfæra alþjóðlega þjónustu.',
        },
        endpointsTable: {
            header: 'Endapunktur alþjóðlegrar þjónustu',
            column: {
                identifer: 'Kennimerki',
                httpMethod: 'Http-aðferð',
                url: 'Hlekkur',
            },
        },
    },
    price_breakdown_details: {
        detailed_breakup: 'Nákvæm sundurliðun',
        total_cost: 'Samtals kostnaður',
        conversion_rate: 'Gengi',
        totalNetCost: 'Heildar Nettókostnaður',
        total_parking_cost: 'Heildarbílastæðiskostnaður',
        total_energy_cost: 'Heildarorkukostnaður',
        total_fixed_cost: 'Heildarföst kostnaður',
        total_time_cost: 'Heildarhleðslutímakostnaður',
    },
    SubscriptionImages: {
        title: 'Myndir premium-áskriftar',
        manageSubscriptionImage: 'Sjá um myndir premium-áskriftar',
        label: {
            name: 'Nafn',
            description: 'Lýsing',
            action: 'Aðgerð',
            delete: 'Eyða',
            image: 'Mynd',
            language: 'Tungumál',
        },
        button: {
            edit: 'Breyta',
            search: 'Leita',
            reset: 'Endurstilla',
            add: 'Bæta við',
        },
        message: {
            deleteConfirmMesage: 'Ertu viss um að þú viljir eyða?',
        },
        errors: {
            insertEnglishLanguageImage: 'Vinsamlega hladdu upp mynd fyrir ensku',
            required: 'Mynd vantar.',
        },
    },
    driverPaymentCards: {
        title: 'Greiðslukort bílstjóra : InstVolt - eMobility þjónustuvettvangur',
        header: 'Greiðslukort',
        label: {},
    },
};
